(function (z) {
  typeof define == "function" && define.amd ? define(z) : z();
})(function () {
  "use strict";
  var z,
    R,
    Ye,
    W,
    Qe,
    et,
    Re,
    tt,
    Ae,
    Te,
    Oe,
    Y = {},
    nt = [],
    xn = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
    xe = Array.isArray;
  function q(e, t) {
    for (var n in t) e[n] = t[n];
    return e;
  }
  function Fe(e) {
    e && e.parentNode && e.parentNode.removeChild(e);
  }
  function Ce(e, t, n) {
    var r,
      s,
      o,
      i = {};
    for (o in t)
      o == "key" ? (r = t[o]) : o == "ref" ? (s = t[o]) : (i[o] = t[o]);
    if (
      (arguments.length > 2 &&
        (i.children = arguments.length > 3 ? z.call(arguments, 2) : n),
      typeof e == "function" && e.defaultProps != null)
    )
      for (o in e.defaultProps) i[o] === void 0 && (i[o] = e.defaultProps[o]);
    return oe(e, i, r, s, null);
  }
  function oe(e, t, n, r, s) {
    var o = {
      type: e,
      props: t,
      key: n,
      ref: r,
      __k: null,
      __: null,
      __b: 0,
      __e: null,
      __c: null,
      constructor: void 0,
      __v: s ?? ++Ye,
      __i: -1,
      __u: 0,
    };
    return s == null && R.vnode != null && R.vnode(o), o;
  }
  function ie(e) {
    return e.children;
  }
  function ae(e, t) {
    (this.props = e), (this.context = t);
  }
  function X(e, t) {
    if (t == null) return e.__ ? X(e.__, e.__i + 1) : null;
    for (var n; t < e.__k.length; t++)
      if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
    return typeof e.type == "function" ? X(e) : null;
  }
  function rt(e) {
    var t, n;
    if ((e = e.__) != null && e.__c != null) {
      for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
        if ((n = e.__k[t]) != null && n.__e != null) {
          e.__e = e.__c.base = n.__e;
          break;
        }
      return rt(e);
    }
  }
  function st(e) {
    ((!e.__d && (e.__d = !0) && W.push(e) && !ce.__r++) ||
      Qe !== R.debounceRendering) &&
      ((Qe = R.debounceRendering) || et)(ce);
  }
  function ce() {
    var e, t, n, r, s, o, i, a;
    for (W.sort(Re); (e = W.shift()); )
      e.__d &&
        ((t = W.length),
        (r = void 0),
        (o = (s = (n = e).__v).__e),
        (i = []),
        (a = []),
        n.__P &&
          (((r = q({}, s)).__v = s.__v + 1),
          R.vnode && R.vnode(r),
          Ne(
            n.__P,
            r,
            s,
            n.__n,
            n.__P.namespaceURI,
            32 & s.__u ? [o] : null,
            i,
            o ?? X(s),
            !!(32 & s.__u),
            a
          ),
          (r.__v = s.__v),
          (r.__.__k[r.__i] = r),
          lt(i, r, a),
          r.__e != o && rt(r)),
        W.length > t && W.sort(Re));
    ce.__r = 0;
  }
  function ot(e, t, n, r, s, o, i, a, u, l, d) {
    var c,
      _,
      m,
      p,
      y,
      h,
      g = (r && r.__k) || nt,
      b = t.length;
    for (u = Fn(n, t, g, u, b), c = 0; c < b; c++)
      (m = n.__k[c]) != null &&
        ((_ = m.__i === -1 ? Y : g[m.__i] || Y),
        (m.__i = c),
        (h = Ne(e, m, _, s, o, i, a, u, l, d)),
        (p = m.__e),
        m.ref &&
          _.ref != m.ref &&
          (_.ref && Pe(_.ref, null, m), d.push(m.ref, m.__c || p, m)),
        y == null && p != null && (y = p),
        4 & m.__u || _.__k === m.__k
          ? (u = it(m, u, e))
          : typeof m.type == "function" && h !== void 0
          ? (u = h)
          : p && (u = p.nextSibling),
        (m.__u &= -7));
    return (n.__e = y), u;
  }
  function Fn(e, t, n, r, s) {
    var o,
      i,
      a,
      u,
      l,
      d = n.length,
      c = d,
      _ = 0;
    for (e.__k = new Array(s), o = 0; o < s; o++)
      (i = t[o]) != null && typeof i != "boolean" && typeof i != "function"
        ? ((u = o + _),
          ((i = e.__k[o] =
            typeof i == "string" ||
            typeof i == "number" ||
            typeof i == "bigint" ||
            i.constructor == String
              ? oe(null, i, null, null, null)
              : xe(i)
              ? oe(ie, { children: i }, null, null, null)
              : i.constructor === void 0 && i.__b > 0
              ? oe(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v)
              : i).__ = e),
          (i.__b = e.__b + 1),
          (a = null),
          (l = i.__i = Cn(i, n, u, c)) !== -1 &&
            (c--, (a = n[l]) && (a.__u |= 2)),
          a == null || a.__v === null
            ? (l == -1 && _--, typeof i.type != "function" && (i.__u |= 4))
            : l != u &&
              (l == u - 1
                ? _--
                : l == u + 1
                ? _++
                : (l > u ? _-- : _++, (i.__u |= 4))))
        : (e.__k[o] = null);
    if (c)
      for (o = 0; o < d; o++)
        (a = n[o]) != null &&
          !(2 & a.__u) &&
          (a.__e == r && (r = X(a)), ut(a, a));
    return r;
  }
  function it(e, t, n) {
    var r, s;
    if (typeof e.type == "function") {
      for (r = e.__k, s = 0; r && s < r.length; s++)
        r[s] && ((r[s].__ = e), (t = it(r[s], t, n)));
      return t;
    }
    e.__e != t &&
      (t && e.type && !n.contains(t) && (t = X(e)),
      n.insertBefore(e.__e, t || null),
      (t = e.__e));
    do t = t && t.nextSibling;
    while (t != null && t.nodeType == 8);
    return t;
  }
  function Cn(e, t, n, r) {
    var s,
      o,
      i = e.key,
      a = e.type,
      u = t[n];
    if (u === null || (u && i == u.key && a === u.type && !(2 & u.__u)))
      return n;
    if (r > (u != null && !(2 & u.__u) ? 1 : 0))
      for (s = n - 1, o = n + 1; s >= 0 || o < t.length; ) {
        if (s >= 0) {
          if ((u = t[s]) && !(2 & u.__u) && i == u.key && a === u.type)
            return s;
          s--;
        }
        if (o < t.length) {
          if ((u = t[o]) && !(2 & u.__u) && i == u.key && a === u.type)
            return o;
          o++;
        }
      }
    return -1;
  }
  function at(e, t, n) {
    t[0] == "-"
      ? e.setProperty(t, n ?? "")
      : (e[t] =
          n == null ? "" : typeof n != "number" || xn.test(t) ? n : n + "px");
  }
  function le(e, t, n, r, s) {
    var o;
    e: if (t == "style")
      if (typeof n == "string") e.style.cssText = n;
      else {
        if ((typeof r == "string" && (e.style.cssText = r = ""), r))
          for (t in r) (n && t in n) || at(e.style, t, "");
        if (n) for (t in n) (r && n[t] === r[t]) || at(e.style, t, n[t]);
      }
    else if (t[0] == "o" && t[1] == "n")
      (o = t != (t = t.replace(tt, "$1"))),
        (t =
          t.toLowerCase() in e || t == "onFocusOut" || t == "onFocusIn"
            ? t.toLowerCase().slice(2)
            : t.slice(2)),
        e.l || (e.l = {}),
        (e.l[t + o] = n),
        n
          ? r
            ? (n.u = r.u)
            : ((n.u = Ae), e.addEventListener(t, o ? Oe : Te, o))
          : e.removeEventListener(t, o ? Oe : Te, o);
    else {
      if (s == "http://www.w3.org/2000/svg")
        t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (
        t != "width" &&
        t != "height" &&
        t != "href" &&
        t != "list" &&
        t != "form" &&
        t != "tabIndex" &&
        t != "download" &&
        t != "rowSpan" &&
        t != "colSpan" &&
        t != "role" &&
        t != "popover" &&
        t in e
      )
        try {
          e[t] = n ?? "";
          break e;
        } catch {}
      typeof n == "function" ||
        (n == null || (n === !1 && t[4] != "-")
          ? e.removeAttribute(t)
          : e.setAttribute(t, t == "popover" && n == 1 ? "" : n));
    }
  }
  function ct(e) {
    return function (t) {
      if (this.l) {
        var n = this.l[t.type + e];
        if (t.t == null) t.t = Ae++;
        else if (t.t < n.u) return;
        return n(R.event ? R.event(t) : t);
      }
    };
  }
  function Ne(e, t, n, r, s, o, i, a, u, l) {
    var d,
      c,
      _,
      m,
      p,
      y,
      h,
      g,
      b,
      A,
      T,
      C,
      U,
      E,
      S,
      k,
      D,
      v = t.type;
    if (t.constructor !== void 0) return null;
    128 & n.__u && ((u = !!(32 & n.__u)), (o = [(a = t.__e = n.__e)])),
      (d = R.__b) && d(t);
    e: if (typeof v == "function")
      try {
        if (
          ((g = t.props),
          (b = "prototype" in v && v.prototype.render),
          (A = (d = v.contextType) && r[d.__c]),
          (T = d ? (A ? A.props.value : d.__) : r),
          n.__c
            ? (h = (c = t.__c = n.__c).__ = c.__E)
            : (b
                ? (t.__c = c = new v(g, T))
                : ((t.__c = c = new ae(g, T)),
                  (c.constructor = v),
                  (c.render = Pn)),
              A && A.sub(c),
              (c.props = g),
              c.state || (c.state = {}),
              (c.context = T),
              (c.__n = r),
              (_ = c.__d = !0),
              (c.__h = []),
              (c._sb = [])),
          b && c.__s == null && (c.__s = c.state),
          b &&
            v.getDerivedStateFromProps != null &&
            (c.__s == c.state && (c.__s = q({}, c.__s)),
            q(c.__s, v.getDerivedStateFromProps(g, c.__s))),
          (m = c.props),
          (p = c.state),
          (c.__v = t),
          _)
        )
          b &&
            v.getDerivedStateFromProps == null &&
            c.componentWillMount != null &&
            c.componentWillMount(),
            b && c.componentDidMount != null && c.__h.push(c.componentDidMount);
        else {
          if (
            (b &&
              v.getDerivedStateFromProps == null &&
              g !== m &&
              c.componentWillReceiveProps != null &&
              c.componentWillReceiveProps(g, T),
            !c.__e &&
              ((c.shouldComponentUpdate != null &&
                c.shouldComponentUpdate(g, c.__s, T) === !1) ||
                t.__v == n.__v))
          ) {
            for (
              t.__v != n.__v &&
                ((c.props = g), (c.state = c.__s), (c.__d = !1)),
                t.__e = n.__e,
                t.__k = n.__k,
                t.__k.some(function (se) {
                  se && (se.__ = t);
                }),
                C = 0;
              C < c._sb.length;
              C++
            )
              c.__h.push(c._sb[C]);
            (c._sb = []), c.__h.length && i.push(c);
            break e;
          }
          c.componentWillUpdate != null && c.componentWillUpdate(g, c.__s, T),
            b &&
              c.componentDidUpdate != null &&
              c.__h.push(function () {
                c.componentDidUpdate(m, p, y);
              });
        }
        if (
          ((c.context = T),
          (c.props = g),
          (c.__P = e),
          (c.__e = !1),
          (U = R.__r),
          (E = 0),
          b)
        ) {
          for (
            c.state = c.__s,
              c.__d = !1,
              U && U(t),
              d = c.render(c.props, c.state, c.context),
              S = 0;
            S < c._sb.length;
            S++
          )
            c.__h.push(c._sb[S]);
          c._sb = [];
        } else
          do
            (c.__d = !1),
              U && U(t),
              (d = c.render(c.props, c.state, c.context)),
              (c.state = c.__s);
          while (c.__d && ++E < 25);
        (c.state = c.__s),
          c.getChildContext != null && (r = q(q({}, r), c.getChildContext())),
          b &&
            !_ &&
            c.getSnapshotBeforeUpdate != null &&
            (y = c.getSnapshotBeforeUpdate(m, p)),
          (a = ot(
            e,
            xe(
              (k =
                d != null && d.type === ie && d.key == null
                  ? d.props.children
                  : d)
            )
              ? k
              : [k],
            t,
            n,
            r,
            s,
            o,
            i,
            a,
            u,
            l
          )),
          (c.base = t.__e),
          (t.__u &= -161),
          c.__h.length && i.push(c),
          h && (c.__E = c.__ = null);
      } catch (se) {
        if (((t.__v = null), u || o != null))
          if (se.then) {
            for (
              t.__u |= u ? 160 : 128;
              a && a.nodeType == 8 && a.nextSibling;

            )
              a = a.nextSibling;
            (o[o.indexOf(a)] = null), (t.__e = a);
          } else for (D = o.length; D--; ) Fe(o[D]);
        else (t.__e = n.__e), (t.__k = n.__k);
        R.__e(se, t, n);
      }
    else
      o == null && t.__v == n.__v
        ? ((t.__k = n.__k), (t.__e = n.__e))
        : (a = t.__e = Nn(n.__e, t, n, r, s, o, i, u, l));
    return (d = R.diffed) && d(t), 128 & t.__u ? void 0 : a;
  }
  function lt(e, t, n) {
    for (var r = 0; r < n.length; r++) Pe(n[r], n[++r], n[++r]);
    R.__c && R.__c(t, e),
      e.some(function (s) {
        try {
          (e = s.__h),
            (s.__h = []),
            e.some(function (o) {
              o.call(s);
            });
        } catch (o) {
          R.__e(o, s.__v);
        }
      });
  }
  function Nn(e, t, n, r, s, o, i, a, u) {
    var l,
      d,
      c,
      _,
      m,
      p,
      y,
      h = n.props,
      g = t.props,
      b = t.type;
    if (
      (b == "svg"
        ? (s = "http://www.w3.org/2000/svg")
        : b == "math"
        ? (s = "http://www.w3.org/1998/Math/MathML")
        : s || (s = "http://www.w3.org/1999/xhtml"),
      o != null)
    ) {
      for (l = 0; l < o.length; l++)
        if (
          (m = o[l]) &&
          "setAttribute" in m == !!b &&
          (b ? m.localName == b : m.nodeType == 3)
        ) {
          (e = m), (o[l] = null);
          break;
        }
    }
    if (e == null) {
      if (b == null) return document.createTextNode(g);
      (e = document.createElementNS(s, b, g.is && g)),
        a && (R.__m && R.__m(t, o), (a = !1)),
        (o = null);
    }
    if (b === null) h === g || (a && e.data === g) || (e.data = g);
    else {
      if (
        ((o = o && z.call(e.childNodes)), (h = n.props || Y), !a && o != null)
      )
        for (h = {}, l = 0; l < e.attributes.length; l++)
          h[(m = e.attributes[l]).name] = m.value;
      for (l in h)
        if (((m = h[l]), l != "children")) {
          if (l == "dangerouslySetInnerHTML") c = m;
          else if (!(l in g)) {
            if (
              (l == "value" && "defaultValue" in g) ||
              (l == "checked" && "defaultChecked" in g)
            )
              continue;
            le(e, l, null, m, s);
          }
        }
      for (l in g)
        (m = g[l]),
          l == "children"
            ? (_ = m)
            : l == "dangerouslySetInnerHTML"
            ? (d = m)
            : l == "value"
            ? (p = m)
            : l == "checked"
            ? (y = m)
            : (a && typeof m != "function") ||
              h[l] === m ||
              le(e, l, m, h[l], s);
      if (d)
        a ||
          (c && (d.__html === c.__html || d.__html === e.innerHTML)) ||
          (e.innerHTML = d.__html),
          (t.__k = []);
      else if (
        (c && (e.innerHTML = ""),
        ot(
          e,
          xe(_) ? _ : [_],
          t,
          n,
          r,
          b == "foreignObject" ? "http://www.w3.org/1999/xhtml" : s,
          o,
          i,
          o ? o[0] : n.__k && X(n, 0),
          a,
          u
        ),
        o != null)
      )
        for (l = o.length; l--; ) Fe(o[l]);
      a ||
        ((l = "value"),
        b == "progress" && p == null
          ? e.removeAttribute("value")
          : p !== void 0 &&
            (p !== e[l] ||
              (b == "progress" && !p) ||
              (b == "option" && p !== h[l])) &&
            le(e, l, p, h[l], s),
        (l = "checked"),
        y !== void 0 && y !== e[l] && le(e, l, y, h[l], s));
    }
    return e;
  }
  function Pe(e, t, n) {
    try {
      if (typeof e == "function") {
        var r = typeof e.__u == "function";
        r && e.__u(), (r && t == null) || (e.__u = e(t));
      } else e.current = t;
    } catch (s) {
      R.__e(s, n);
    }
  }
  function ut(e, t, n) {
    var r, s;
    if (
      (R.unmount && R.unmount(e),
      (r = e.ref) && ((r.current && r.current !== e.__e) || Pe(r, null, t)),
      (r = e.__c) != null)
    ) {
      if (r.componentWillUnmount)
        try {
          r.componentWillUnmount();
        } catch (o) {
          R.__e(o, t);
        }
      r.base = r.__P = null;
    }
    if ((r = e.__k))
      for (s = 0; s < r.length; s++)
        r[s] && ut(r[s], t, n || typeof e.type != "function");
    n || Fe(e.__e), (e.__c = e.__ = e.__e = void 0);
  }
  function Pn(e, t, n) {
    return this.constructor(e, n);
  }
  function kn(e, t, n) {
    var r, s, o, i;
    t == document && (t = document.documentElement),
      R.__ && R.__(e, t),
      (s = (r = !1) ? null : t.__k),
      (o = []),
      (i = []),
      Ne(
        t,
        (e = t.__k = Ce(ie, null, [e])),
        s || Y,
        Y,
        t.namespaceURI,
        s ? null : t.firstChild ? z.call(t.childNodes) : null,
        o,
        s ? s.__e : t.firstChild,
        r,
        i
      ),
      lt(o, e, i);
  }
  (z = nt.slice),
    (R = {
      __e: function (e, t, n, r) {
        for (var s, o, i; (t = t.__); )
          if ((s = t.__c) && !s.__)
            try {
              if (
                ((o = s.constructor) &&
                  o.getDerivedStateFromError != null &&
                  (s.setState(o.getDerivedStateFromError(e)), (i = s.__d)),
                s.componentDidCatch != null &&
                  (s.componentDidCatch(e, r || {}), (i = s.__d)),
                i)
              )
                return (s.__E = s);
            } catch (a) {
              e = a;
            }
        throw e;
      },
    }),
    (Ye = 0),
    (ae.prototype.setState = function (e, t) {
      var n;
      (n =
        this.__s != null && this.__s !== this.state
          ? this.__s
          : (this.__s = q({}, this.state))),
        typeof e == "function" && (e = e(q({}, n), this.props)),
        e && q(n, e),
        e != null && this.__v && (t && this._sb.push(t), st(this));
    }),
    (ae.prototype.forceUpdate = function (e) {
      this.__v && ((this.__e = !0), e && this.__h.push(e), st(this));
    }),
    (ae.prototype.render = ie),
    (W = []),
    (et =
      typeof Promise == "function"
        ? Promise.prototype.then.bind(Promise.resolve())
        : setTimeout),
    (Re = function (e, t) {
      return e.__v.__b - t.__v.__b;
    }),
    (ce.__r = 0),
    (tt = /(PointerCapture)$|Capture$/i),
    (Ae = 0),
    (Te = ct(!1)),
    (Oe = ct(!0));
  var Dn = 0;
  function O(e, t, n, r, s, o) {
    t || (t = {});
    var i,
      a,
      u = t;
    if ("ref" in u)
      for (a in ((u = {}), t)) a == "ref" ? (i = t[a]) : (u[a] = t[a]);
    var l = {
      type: e,
      props: u,
      key: n,
      ref: i,
      __k: null,
      __: null,
      __b: 0,
      __e: null,
      __c: null,
      constructor: void 0,
      __v: --Dn,
      __i: -1,
      __u: 0,
      __source: s,
      __self: o,
    };
    if (typeof e == "function" && (i = e.defaultProps))
      for (a in i) u[a] === void 0 && (u[a] = i[a]);
    return R.vnode && R.vnode(l), l;
  }
  var ft = function (e, t, n, r) {
      var s;
      t[0] = 0;
      for (var o = 1; o < t.length; o++) {
        var i = t[o++],
          a = t[o] ? ((t[0] |= i ? 1 : 2), n[t[o++]]) : t[++o];
        i === 3
          ? (r[0] = a)
          : i === 4
          ? (r[1] = Object.assign(r[1] || {}, a))
          : i === 5
          ? ((r[1] = r[1] || {})[t[++o]] = a)
          : i === 6
          ? (r[1][t[++o]] += a + "")
          : i
          ? ((s = e.apply(a, ft(e, a, n, ["", null]))),
            r.push(s),
            a[0] ? (t[0] |= 2) : ((t[o - 2] = 0), (t[o] = s)))
          : r.push(a);
      }
      return r;
    },
    dt = new Map();
  function Ln(e) {
    var t = dt.get(this);
    return (
      t || ((t = new Map()), dt.set(this, t)),
      (t = ft(
        this,
        t.get(e) ||
          (t.set(
            e,
            (t = (function (n) {
              for (
                var r,
                  s,
                  o = 1,
                  i = "",
                  a = "",
                  u = [0],
                  l = function (_) {
                    o === 1 &&
                    (_ || (i = i.replace(/^\s*\n\s*|\s*\n\s*$/g, "")))
                      ? u.push(0, _, i)
                      : o === 3 && (_ || i)
                      ? (u.push(3, _, i), (o = 2))
                      : o === 2 && i === "..." && _
                      ? u.push(4, _, 0)
                      : o === 2 && i && !_
                      ? u.push(5, 0, !0, i)
                      : o >= 5 &&
                        ((i || (!_ && o === 5)) &&
                          (u.push(o, 0, i, s), (o = 6)),
                        _ && (u.push(o, _, 0, s), (o = 6))),
                      (i = "");
                  },
                  d = 0;
                d < n.length;
                d++
              ) {
                d && (o === 1 && l(), l(d));
                for (var c = 0; c < n[d].length; c++)
                  (r = n[d][c]),
                    o === 1
                      ? r === "<"
                        ? (l(), (u = [u]), (o = 3))
                        : (i += r)
                      : o === 4
                      ? i === "--" && r === ">"
                        ? ((o = 1), (i = ""))
                        : (i = r + i[0])
                      : a
                      ? r === a
                        ? (a = "")
                        : (i += r)
                      : r === '"' || r === "'"
                      ? (a = r)
                      : r === ">"
                      ? (l(), (o = 1))
                      : o &&
                        (r === "="
                          ? ((o = 5), (s = i), (i = ""))
                          : r === "/" && (o < 5 || n[d][c + 1] === ">")
                          ? (l(),
                            o === 3 && (u = u[0]),
                            (o = u),
                            (u = u[0]).push(2, 0, o),
                            (o = 0))
                          : r === " " ||
                            r === "	" ||
                            r ===
                              `
` ||
                            r === "\r"
                          ? (l(), (o = 2))
                          : (i += r)),
                    o === 3 && i === "!--" && ((o = 4), (u = u[0]));
              }
              return l(), u;
            })(e))
          ),
          t),
        arguments,
        []
      )).length > 1
        ? t
        : t[0]
    );
  }
  Ln.bind(Ce);
  var Q,
    x,
    ke,
    _t,
    ue = 0,
    pt = [],
    N = R,
    ht = N.__b,
    mt = N.__r,
    yt = N.diffed,
    gt = N.__c,
    bt = N.unmount,
    wt = N.__;
  function De(e, t) {
    N.__h && N.__h(x, e, ue || t), (ue = 0);
    var n = x.__H || (x.__H = { __: [], __h: [] });
    return e >= n.__.length && n.__.push({}), n.__[e];
  }
  function M(e) {
    return (ue = 1), Un(At, e);
  }
  function Un(e, t, n) {
    var r = De(Q++, 2);
    if (
      ((r.t = e),
      !r.__c &&
        ((r.__ = [
          At(void 0, t),
          function (a) {
            var u = r.__N ? r.__N[0] : r.__[0],
              l = r.t(u, a);
            u !== l && ((r.__N = [l, r.__[1]]), r.__c.setState({}));
          },
        ]),
        (r.__c = x),
        !x.u))
    ) {
      var s = function (a, u, l) {
        if (!r.__c.__H) return !0;
        var d = r.__c.__H.__.filter(function (_) {
          return !!_.__c;
        });
        if (
          d.every(function (_) {
            return !_.__N;
          })
        )
          return !o || o.call(this, a, u, l);
        var c = r.__c.props !== a;
        return (
          d.forEach(function (_) {
            if (_.__N) {
              var m = _.__[0];
              (_.__ = _.__N), (_.__N = void 0), m !== _.__[0] && (c = !0);
            }
          }),
          (o && o.call(this, a, u, l)) || c
        );
      };
      x.u = !0;
      var o = x.shouldComponentUpdate,
        i = x.componentWillUpdate;
      (x.componentWillUpdate = function (a, u, l) {
        if (this.__e) {
          var d = o;
          (o = void 0), s(a, u, l), (o = d);
        }
        i && i.call(this, a, u, l);
      }),
        (x.shouldComponentUpdate = s);
    }
    return r.__N || r.__;
  }
  function Et(e, t) {
    var n = De(Q++, 3);
    !N.__s && Rt(n.__H, t) && ((n.__ = e), (n.i = t), x.__H.__h.push(n));
  }
  function vn(e) {
    return (
      (ue = 5),
      jn(function () {
        return { current: e };
      }, [])
    );
  }
  function jn(e, t) {
    var n = De(Q++, 7);
    return Rt(n.__H, t) && ((n.__ = e()), (n.__H = t), (n.__h = e)), n.__;
  }
  function $n() {
    for (var e; (e = pt.shift()); )
      if (e.__P && e.__H)
        try {
          e.__H.__h.forEach(fe), e.__H.__h.forEach(Le), (e.__H.__h = []);
        } catch (t) {
          (e.__H.__h = []), N.__e(t, e.__v);
        }
  }
  (N.__b = function (e) {
    (x = null), ht && ht(e);
  }),
    (N.__ = function (e, t) {
      e && t.__k && t.__k.__m && (e.__m = t.__k.__m), wt && wt(e, t);
    }),
    (N.__r = function (e) {
      mt && mt(e), (Q = 0);
      var t = (x = e.__c).__H;
      t &&
        (ke === x
          ? ((t.__h = []),
            (x.__h = []),
            t.__.forEach(function (n) {
              n.__N && (n.__ = n.__N), (n.i = n.__N = void 0);
            }))
          : (t.__h.forEach(fe), t.__h.forEach(Le), (t.__h = []), (Q = 0))),
        (ke = x);
    }),
    (N.diffed = function (e) {
      yt && yt(e);
      var t = e.__c;
      t &&
        t.__H &&
        (t.__H.__h.length &&
          ((pt.push(t) !== 1 && _t === N.requestAnimationFrame) ||
            ((_t = N.requestAnimationFrame) || Bn)($n)),
        t.__H.__.forEach(function (n) {
          n.i && (n.__H = n.i), (n.i = void 0);
        })),
        (ke = x = null);
    }),
    (N.__c = function (e, t) {
      t.some(function (n) {
        try {
          n.__h.forEach(fe),
            (n.__h = n.__h.filter(function (r) {
              return !r.__ || Le(r);
            }));
        } catch (r) {
          t.some(function (s) {
            s.__h && (s.__h = []);
          }),
            (t = []),
            N.__e(r, n.__v);
        }
      }),
        gt && gt(e, t);
    }),
    (N.unmount = function (e) {
      bt && bt(e);
      var t,
        n = e.__c;
      n &&
        n.__H &&
        (n.__H.__.forEach(function (r) {
          try {
            fe(r);
          } catch (s) {
            t = s;
          }
        }),
        (n.__H = void 0),
        t && N.__e(t, n.__v));
    });
  var St = typeof requestAnimationFrame == "function";
  function Bn(e) {
    var t,
      n = function () {
        clearTimeout(r), St && cancelAnimationFrame(t), setTimeout(e);
      },
      r = setTimeout(n, 100);
    St && (t = requestAnimationFrame(n));
  }
  function fe(e) {
    var t = x,
      n = e.__c;
    typeof n == "function" && ((e.__c = void 0), n()), (x = t);
  }
  function Le(e) {
    var t = x;
    (e.__c = e.__()), (x = t);
  }
  function Rt(e, t) {
    return (
      !e ||
      e.length !== t.length ||
      t.some(function (n, r) {
        return n !== e[r];
      })
    );
  }
  function At(e, t) {
    return typeof t == "function" ? t(e) : t;
  }
  const Tt = "%[a-f0-9]{2}",
    Ot = new RegExp("(" + Tt + ")|([^%]+?)", "gi"),
    xt = new RegExp("(" + Tt + ")+", "gi");
  function Ue(e, t) {
    try {
      return [decodeURIComponent(e.join(""))];
    } catch {}
    if (e.length === 1) return e;
    t = t || 1;
    const n = e.slice(0, t),
      r = e.slice(t);
    return Array.prototype.concat.call([], Ue(n), Ue(r));
  }
  function In(e) {
    try {
      return decodeURIComponent(e);
    } catch {
      let t = e.match(Ot) || [];
      for (let n = 1; n < t.length; n++)
        (e = Ue(t, n).join("")), (t = e.match(Ot) || []);
      return e;
    }
  }
  function Hn(e) {
    const t = { "%FE%FF": "��", "%FF%FE": "��" };
    let n = xt.exec(e);
    for (; n; ) {
      try {
        t[n[0]] = decodeURIComponent(n[0]);
      } catch {
        const s = In(n[0]);
        s !== n[0] && (t[n[0]] = s);
      }
      n = xt.exec(e);
    }
    t["%C2"] = "�";
    const r = Object.keys(t);
    for (const s of r) e = e.replace(new RegExp(s, "g"), t[s]);
    return e;
  }
  function qn(e) {
    if (typeof e != "string")
      throw new TypeError(
        "Expected `encodedURI` to be of type `string`, got `" + typeof e + "`"
      );
    try {
      return decodeURIComponent(e);
    } catch {
      return Hn(e);
    }
  }
  function Mn(e, t) {
    const n = {};
    if (Array.isArray(t))
      for (const r of t) {
        const s = Object.getOwnPropertyDescriptor(e, r);
        s != null && s.enumerable && Object.defineProperty(n, r, s);
      }
    else
      for (const r of Reflect.ownKeys(e)) {
        const s = Object.getOwnPropertyDescriptor(e, r);
        if (s.enumerable) {
          const o = e[r];
          t(r, o, e) && Object.defineProperty(n, r, s);
        }
      }
    return n;
  }
  function Ft(e, t) {
    if (!(typeof e == "string" && typeof t == "string"))
      throw new TypeError("Expected the arguments to be of type `string`");
    if (e === "" || t === "") return [];
    const n = e.indexOf(t);
    return n === -1 ? [] : [e.slice(0, n), e.slice(n + t.length)];
  }
  const zn = (e) => e == null,
    Wn = (e) =>
      encodeURIComponent(e).replaceAll(
        /[!'()*]/g,
        (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`
      ),
    ve = Symbol("encodeFragmentIdentifier");
  function Jn(e) {
    switch (e.arrayFormat) {
      case "index":
        return (t) => (n, r) => {
          const s = n.length;
          return r === void 0 ||
            (e.skipNull && r === null) ||
            (e.skipEmptyString && r === "")
            ? n
            : r === null
            ? [...n, [P(t, e), "[", s, "]"].join("")]
            : [...n, [P(t, e), "[", P(s, e), "]=", P(r, e)].join("")];
        };
      case "bracket":
        return (t) => (n, r) =>
          r === void 0 ||
          (e.skipNull && r === null) ||
          (e.skipEmptyString && r === "")
            ? n
            : r === null
            ? [...n, [P(t, e), "[]"].join("")]
            : [...n, [P(t, e), "[]=", P(r, e)].join("")];
      case "colon-list-separator":
        return (t) => (n, r) =>
          r === void 0 ||
          (e.skipNull && r === null) ||
          (e.skipEmptyString && r === "")
            ? n
            : r === null
            ? [...n, [P(t, e), ":list="].join("")]
            : [...n, [P(t, e), ":list=", P(r, e)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (n) => (r, s) =>
          s === void 0 ||
          (e.skipNull && s === null) ||
          (e.skipEmptyString && s === "")
            ? r
            : ((s = s === null ? "" : s),
              r.length === 0
                ? [[P(n, e), t, P(s, e)].join("")]
                : [[r, P(s, e)].join(e.arrayFormatSeparator)]);
      }
      default:
        return (t) => (n, r) =>
          r === void 0 ||
          (e.skipNull && r === null) ||
          (e.skipEmptyString && r === "")
            ? n
            : r === null
            ? [...n, P(t, e)]
            : [...n, [P(t, e), "=", P(r, e)].join("")];
    }
  }
  function Vn(e) {
    let t;
    switch (e.arrayFormat) {
      case "index":
        return (n, r, s) => {
          if (((t = /\[(\d*)]$/.exec(n)), (n = n.replace(/\[\d*]$/, "")), !t)) {
            s[n] = r;
            return;
          }
          s[n] === void 0 && (s[n] = {}), (s[n][t[1]] = r);
        };
      case "bracket":
        return (n, r, s) => {
          if (((t = /(\[])$/.exec(n)), (n = n.replace(/\[]$/, "")), !t)) {
            s[n] = r;
            return;
          }
          if (s[n] === void 0) {
            s[n] = [r];
            return;
          }
          s[n] = [...s[n], r];
        };
      case "colon-list-separator":
        return (n, r, s) => {
          if (((t = /(:list)$/.exec(n)), (n = n.replace(/:list$/, "")), !t)) {
            s[n] = r;
            return;
          }
          if (s[n] === void 0) {
            s[n] = [r];
            return;
          }
          s[n] = [...s[n], r];
        };
      case "comma":
      case "separator":
        return (n, r, s) => {
          const o = typeof r == "string" && r.includes(e.arrayFormatSeparator),
            i =
              typeof r == "string" &&
              !o &&
              H(r, e).includes(e.arrayFormatSeparator);
          r = i ? H(r, e) : r;
          const a =
            o || i
              ? r.split(e.arrayFormatSeparator).map((u) => H(u, e))
              : r === null
              ? r
              : H(r, e);
          s[n] = a;
        };
      case "bracket-separator":
        return (n, r, s) => {
          const o = /(\[])$/.test(n);
          if (((n = n.replace(/\[]$/, "")), !o)) {
            s[n] = r && H(r, e);
            return;
          }
          const i = r === null ? [] : H(r, e).split(e.arrayFormatSeparator);
          if (s[n] === void 0) {
            s[n] = i;
            return;
          }
          s[n] = [...s[n], ...i];
        };
      default:
        return (n, r, s) => {
          if (s[n] === void 0) {
            s[n] = r;
            return;
          }
          s[n] = [...[s[n]].flat(), r];
        };
    }
  }
  function Ct(e) {
    if (typeof e != "string" || e.length !== 1)
      throw new TypeError(
        "arrayFormatSeparator must be single character string"
      );
  }
  function P(e, t) {
    return t.encode ? (t.strict ? Wn(e) : encodeURIComponent(e)) : e;
  }
  function H(e, t) {
    return t.decode ? qn(e) : e;
  }
  function Nt(e) {
    return Array.isArray(e)
      ? e.sort()
      : typeof e == "object"
      ? Nt(Object.keys(e))
          .sort((t, n) => Number(t) - Number(n))
          .map((t) => e[t])
      : e;
  }
  function Pt(e) {
    const t = e.indexOf("#");
    return t !== -1 && (e = e.slice(0, t)), e;
  }
  function Kn(e) {
    let t = "";
    const n = e.indexOf("#");
    return n !== -1 && (t = e.slice(n)), t;
  }
  function kt(e, t, n) {
    return n === "string" && typeof e == "string"
      ? e
      : typeof n == "function" && typeof e == "string"
      ? n(e)
      : t.parseBooleans &&
        e !== null &&
        (e.toLowerCase() === "true" || e.toLowerCase() === "false")
      ? e.toLowerCase() === "true"
      : (n === "number" &&
          !Number.isNaN(Number(e)) &&
          typeof e == "string" &&
          e.trim() !== "") ||
        (t.parseNumbers &&
          !Number.isNaN(Number(e)) &&
          typeof e == "string" &&
          e.trim() !== "")
      ? Number(e)
      : e;
  }
  function je(e) {
    e = Pt(e);
    const t = e.indexOf("?");
    return t === -1 ? "" : e.slice(t + 1);
  }
  function $e(e, t) {
    (t = {
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1,
      types: Object.create(null),
      ...t,
    }),
      Ct(t.arrayFormatSeparator);
    const n = Vn(t),
      r = Object.create(null);
    if (typeof e != "string" || ((e = e.trim().replace(/^[?#&]/, "")), !e))
      return r;
    for (const s of e.split("&")) {
      if (s === "") continue;
      const o = t.decode ? s.replaceAll("+", " ") : s;
      let [i, a] = Ft(o, "=");
      i === void 0 && (i = o),
        (a =
          a === void 0
            ? null
            : ["comma", "separator", "bracket-separator"].includes(
                t.arrayFormat
              )
            ? a
            : H(a, t)),
        n(H(i, t), a, r);
    }
    for (const [s, o] of Object.entries(r))
      if (typeof o == "object" && o !== null && t.types[s] !== "string")
        for (const [i, a] of Object.entries(o)) {
          const u = t.types[s] ? t.types[s].replace("[]", "") : void 0;
          o[i] = kt(a, t, u);
        }
      else
        typeof o == "object" && o !== null && t.types[s] === "string"
          ? (r[s] = Object.values(o).join(t.arrayFormatSeparator))
          : (r[s] = kt(o, t, t.types[s]));
    return t.sort === !1
      ? r
      : (t.sort === !0
          ? Object.keys(r).sort()
          : Object.keys(r).sort(t.sort)
        ).reduce((s, o) => {
          const i = r[o];
          return (
            (s[o] = i && typeof i == "object" && !Array.isArray(i) ? Nt(i) : i),
            s
          );
        }, Object.create(null));
  }
  function Dt(e, t) {
    if (!e) return "";
    (t = {
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      ...t,
    }),
      Ct(t.arrayFormatSeparator);
    const n = (i) =>
        (t.skipNull && zn(e[i])) || (t.skipEmptyString && e[i] === ""),
      r = Jn(t),
      s = {};
    for (const [i, a] of Object.entries(e)) n(i) || (s[i] = a);
    const o = Object.keys(s);
    return (
      t.sort !== !1 && o.sort(t.sort),
      o
        .map((i) => {
          const a = e[i];
          return a === void 0
            ? ""
            : a === null
            ? P(i, t)
            : Array.isArray(a)
            ? a.length === 0 && t.arrayFormat === "bracket-separator"
              ? P(i, t) + "[]"
              : a.reduce(r(i), []).join("&")
            : P(i, t) + "=" + P(a, t);
        })
        .filter((i) => i.length > 0)
        .join("&")
    );
  }
  function Lt(e, t) {
    var s;
    t = { decode: !0, ...t };
    let [n, r] = Ft(e, "#");
    return (
      n === void 0 && (n = e),
      {
        url:
          ((s = n == null ? void 0 : n.split("?")) == null ? void 0 : s[0]) ??
          "",
        query: $e(je(e), t),
        ...(t && t.parseFragmentIdentifier && r
          ? { fragmentIdentifier: H(r, t) }
          : {}),
      }
    );
  }
  function Ut(e, t) {
    t = { encode: !0, strict: !0, [ve]: !0, ...t };
    const n = Pt(e.url).split("?")[0] || "",
      r = je(e.url),
      s = { ...$e(r, { sort: !1 }), ...e.query };
    let o = Dt(s, t);
    o && (o = `?${o}`);
    let i = Kn(e.url);
    if (typeof e.fragmentIdentifier == "string") {
      const a = new URL(n);
      (a.hash = e.fragmentIdentifier),
        (i = t[ve] ? a.hash : `#${e.fragmentIdentifier}`);
    }
    return `${n}${o}${i}`;
  }
  function vt(e, t, n) {
    n = { parseFragmentIdentifier: !0, [ve]: !1, ...n };
    const { url: r, query: s, fragmentIdentifier: o } = Lt(e, n);
    return Ut({ url: r, query: Mn(s, t), fragmentIdentifier: o }, n);
  }
  function Xn(e, t, n) {
    const r = Array.isArray(t) ? (s) => !t.includes(s) : (s, o) => !t(s, o);
    return vt(e, r, n);
  }
  const Gn = Object.freeze(
    Object.defineProperty(
      {
        __proto__: null,
        exclude: Xn,
        extract: je,
        parse: $e,
        parseUrl: Lt,
        pick: vt,
        stringify: Dt,
        stringifyUrl: Ut,
      },
      Symbol.toStringTag,
      { value: "Module" }
    )
  );
  function jt(e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }
  const { toString: Zn } = Object.prototype,
    { getPrototypeOf: Be } = Object,
    de = ((e) => (t) => {
      const n = Zn.call(t);
      return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
    })(Object.create(null)),
    B = (e) => ((e = e.toLowerCase()), (t) => de(t) === e),
    _e = (e) => (t) => typeof t === e,
    { isArray: G } = Array,
    ee = _e("undefined");
  function Yn(e) {
    return (
      e !== null &&
      !ee(e) &&
      e.constructor !== null &&
      !ee(e.constructor) &&
      $(e.constructor.isBuffer) &&
      e.constructor.isBuffer(e)
    );
  }
  const $t = B("ArrayBuffer");
  function Qn(e) {
    let t;
    return (
      typeof ArrayBuffer < "u" && ArrayBuffer.isView
        ? (t = ArrayBuffer.isView(e))
        : (t = e && e.buffer && $t(e.buffer)),
      t
    );
  }
  const er = _e("string"),
    $ = _e("function"),
    Bt = _e("number"),
    pe = (e) => e !== null && typeof e == "object",
    tr = (e) => e === !0 || e === !1,
    he = (e) => {
      if (de(e) !== "object") return !1;
      const t = Be(e);
      return (
        (t === null ||
          t === Object.prototype ||
          Object.getPrototypeOf(t) === null) &&
        !(Symbol.toStringTag in e) &&
        !(Symbol.iterator in e)
      );
    },
    nr = B("Date"),
    rr = B("File"),
    sr = B("Blob"),
    or = B("FileList"),
    ir = (e) => pe(e) && $(e.pipe),
    ar = (e) => {
      let t;
      return (
        e &&
        ((typeof FormData == "function" && e instanceof FormData) ||
          ($(e.append) &&
            ((t = de(e)) === "formdata" ||
              (t === "object" &&
                $(e.toString) &&
                e.toString() === "[object FormData]"))))
      );
    },
    cr = B("URLSearchParams"),
    [lr, ur, fr, dr] = ["ReadableStream", "Request", "Response", "Headers"].map(
      B
    ),
    _r = (e) =>
      e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
  function te(e, t, { allOwnKeys: n = !1 } = {}) {
    if (e === null || typeof e > "u") return;
    let r, s;
    if ((typeof e != "object" && (e = [e]), G(e)))
      for (r = 0, s = e.length; r < s; r++) t.call(null, e[r], r, e);
    else {
      const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e),
        i = o.length;
      let a;
      for (r = 0; r < i; r++) (a = o[r]), t.call(null, e[a], a, e);
    }
  }
  function It(e, t) {
    t = t.toLowerCase();
    const n = Object.keys(e);
    let r = n.length,
      s;
    for (; r-- > 0; ) if (((s = n[r]), t === s.toLowerCase())) return s;
    return null;
  }
  const J =
      typeof globalThis < "u"
        ? globalThis
        : typeof self < "u"
        ? self
        : typeof window < "u"
        ? window
        : global,
    Ht = (e) => !ee(e) && e !== J;
  function Ie() {
    const { caseless: e } = (Ht(this) && this) || {},
      t = {},
      n = (r, s) => {
        const o = (e && It(t, s)) || s;
        he(t[o]) && he(r)
          ? (t[o] = Ie(t[o], r))
          : he(r)
          ? (t[o] = Ie({}, r))
          : G(r)
          ? (t[o] = r.slice())
          : (t[o] = r);
      };
    for (let r = 0, s = arguments.length; r < s; r++)
      arguments[r] && te(arguments[r], n);
    return t;
  }
  const pr = (e, t, n, { allOwnKeys: r } = {}) => (
      te(
        t,
        (s, o) => {
          n && $(s) ? (e[o] = jt(s, n)) : (e[o] = s);
        },
        { allOwnKeys: r }
      ),
      e
    ),
    hr = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e),
    mr = (e, t, n, r) => {
      (e.prototype = Object.create(t.prototype, r)),
        (e.prototype.constructor = e),
        Object.defineProperty(e, "super", { value: t.prototype }),
        n && Object.assign(e.prototype, n);
    },
    yr = (e, t, n, r) => {
      let s, o, i;
      const a = {};
      if (((t = t || {}), e == null)) return t;
      do {
        for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
          (i = s[o]),
            (!r || r(i, e, t)) && !a[i] && ((t[i] = e[i]), (a[i] = !0));
        e = n !== !1 && Be(e);
      } while (e && (!n || n(e, t)) && e !== Object.prototype);
      return t;
    },
    gr = (e, t, n) => {
      (e = String(e)),
        (n === void 0 || n > e.length) && (n = e.length),
        (n -= t.length);
      const r = e.indexOf(t, n);
      return r !== -1 && r === n;
    },
    br = (e) => {
      if (!e) return null;
      if (G(e)) return e;
      let t = e.length;
      if (!Bt(t)) return null;
      const n = new Array(t);
      for (; t-- > 0; ) n[t] = e[t];
      return n;
    },
    wr = (
      (e) => (t) =>
        e && t instanceof e
    )(typeof Uint8Array < "u" && Be(Uint8Array)),
    Er = (e, t) => {
      const r = (e && e[Symbol.iterator]).call(e);
      let s;
      for (; (s = r.next()) && !s.done; ) {
        const o = s.value;
        t.call(e, o[0], o[1]);
      }
    },
    Sr = (e, t) => {
      let n;
      const r = [];
      for (; (n = e.exec(t)) !== null; ) r.push(n);
      return r;
    },
    Rr = B("HTMLFormElement"),
    Ar = (e) =>
      e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function (n, r, s) {
        return r.toUpperCase() + s;
      }),
    qt = (
      ({ hasOwnProperty: e }) =>
      (t, n) =>
        e.call(t, n)
    )(Object.prototype),
    Tr = B("RegExp"),
    Mt = (e, t) => {
      const n = Object.getOwnPropertyDescriptors(e),
        r = {};
      te(n, (s, o) => {
        let i;
        (i = t(s, o, e)) !== !1 && (r[o] = i || s);
      }),
        Object.defineProperties(e, r);
    },
    Or = (e) => {
      Mt(e, (t, n) => {
        if ($(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
          return !1;
        const r = e[n];
        if ($(r)) {
          if (((t.enumerable = !1), "writable" in t)) {
            t.writable = !1;
            return;
          }
          t.set ||
            (t.set = () => {
              throw Error("Can not rewrite read-only method '" + n + "'");
            });
        }
      });
    },
    xr = (e, t) => {
      const n = {},
        r = (s) => {
          s.forEach((o) => {
            n[o] = !0;
          });
        };
      return G(e) ? r(e) : r(String(e).split(t)), n;
    },
    Fr = () => {},
    Cr = (e, t) => (e != null && Number.isFinite((e = +e)) ? e : t),
    He = "abcdefghijklmnopqrstuvwxyz",
    zt = "0123456789",
    Wt = { DIGIT: zt, ALPHA: He, ALPHA_DIGIT: He + He.toUpperCase() + zt },
    Nr = (e = 16, t = Wt.ALPHA_DIGIT) => {
      let n = "";
      const { length: r } = t;
      for (; e--; ) n += t[(Math.random() * r) | 0];
      return n;
    };
  function Pr(e) {
    return !!(
      e &&
      $(e.append) &&
      e[Symbol.toStringTag] === "FormData" &&
      e[Symbol.iterator]
    );
  }
  const kr = (e) => {
      const t = new Array(10),
        n = (r, s) => {
          if (pe(r)) {
            if (t.indexOf(r) >= 0) return;
            if (!("toJSON" in r)) {
              t[s] = r;
              const o = G(r) ? [] : {};
              return (
                te(r, (i, a) => {
                  const u = n(i, s + 1);
                  !ee(u) && (o[a] = u);
                }),
                (t[s] = void 0),
                o
              );
            }
          }
          return r;
        };
      return n(e, 0);
    },
    Dr = B("AsyncFunction"),
    Lr = (e) => e && (pe(e) || $(e)) && $(e.then) && $(e.catch),
    Jt = ((e, t) =>
      e
        ? setImmediate
        : t
        ? ((n, r) => (
            J.addEventListener(
              "message",
              ({ source: s, data: o }) => {
                s === J && o === n && r.length && r.shift()();
              },
              !1
            ),
            (s) => {
              r.push(s), J.postMessage(n, "*");
            }
          ))(`axios@${Math.random()}`, [])
        : (n) => setTimeout(n))(
      typeof setImmediate == "function",
      $(J.postMessage)
    ),
    Ur =
      typeof queueMicrotask < "u"
        ? queueMicrotask.bind(J)
        : (typeof process < "u" && process.nextTick) || Jt,
    f = {
      isArray: G,
      isArrayBuffer: $t,
      isBuffer: Yn,
      isFormData: ar,
      isArrayBufferView: Qn,
      isString: er,
      isNumber: Bt,
      isBoolean: tr,
      isObject: pe,
      isPlainObject: he,
      isReadableStream: lr,
      isRequest: ur,
      isResponse: fr,
      isHeaders: dr,
      isUndefined: ee,
      isDate: nr,
      isFile: rr,
      isBlob: sr,
      isRegExp: Tr,
      isFunction: $,
      isStream: ir,
      isURLSearchParams: cr,
      isTypedArray: wr,
      isFileList: or,
      forEach: te,
      merge: Ie,
      extend: pr,
      trim: _r,
      stripBOM: hr,
      inherits: mr,
      toFlatObject: yr,
      kindOf: de,
      kindOfTest: B,
      endsWith: gr,
      toArray: br,
      forEachEntry: Er,
      matchAll: Sr,
      isHTMLForm: Rr,
      hasOwnProperty: qt,
      hasOwnProp: qt,
      reduceDescriptors: Mt,
      freezeMethods: Or,
      toObjectSet: xr,
      toCamelCase: Ar,
      noop: Fr,
      toFiniteNumber: Cr,
      findKey: It,
      global: J,
      isContextDefined: Ht,
      ALPHABET: Wt,
      generateString: Nr,
      isSpecCompliantForm: Pr,
      toJSONObject: kr,
      isAsyncFn: Dr,
      isThenable: Lr,
      setImmediate: Jt,
      asap: Ur,
    };
  function w(e, t, n, r, s) {
    Error.call(this),
      Error.captureStackTrace
        ? Error.captureStackTrace(this, this.constructor)
        : (this.stack = new Error().stack),
      (this.message = e),
      (this.name = "AxiosError"),
      t && (this.code = t),
      n && (this.config = n),
      r && (this.request = r),
      s && ((this.response = s), (this.status = s.status ? s.status : null));
  }
  f.inherits(w, Error, {
    toJSON: function () {
      return {
        message: this.message,
        name: this.name,
        description: this.description,
        number: this.number,
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        config: f.toJSONObject(this.config),
        code: this.code,
        status: this.status,
      };
    },
  });
  const Vt = w.prototype,
    Kt = {};
  [
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL",
  ].forEach((e) => {
    Kt[e] = { value: e };
  }),
    Object.defineProperties(w, Kt),
    Object.defineProperty(Vt, "isAxiosError", { value: !0 }),
    (w.from = (e, t, n, r, s, o) => {
      const i = Object.create(Vt);
      return (
        f.toFlatObject(
          e,
          i,
          function (u) {
            return u !== Error.prototype;
          },
          (a) => a !== "isAxiosError"
        ),
        w.call(i, e.message, t, n, r, s),
        (i.cause = e),
        (i.name = e.name),
        o && Object.assign(i, o),
        i
      );
    });
  const vr = null;
  function qe(e) {
    return f.isPlainObject(e) || f.isArray(e);
  }
  function Xt(e) {
    return f.endsWith(e, "[]") ? e.slice(0, -2) : e;
  }
  function Gt(e, t, n) {
    return e
      ? e
          .concat(t)
          .map(function (s, o) {
            return (s = Xt(s)), !n && o ? "[" + s + "]" : s;
          })
          .join(n ? "." : "")
      : t;
  }
  function jr(e) {
    return f.isArray(e) && !e.some(qe);
  }
  const $r = f.toFlatObject(f, {}, null, function (t) {
    return /^is[A-Z]/.test(t);
  });
  function me(e, t, n) {
    if (!f.isObject(e)) throw new TypeError("target must be an object");
    (t = t || new FormData()),
      (n = f.toFlatObject(
        n,
        { metaTokens: !0, dots: !1, indexes: !1 },
        !1,
        function (y, h) {
          return !f.isUndefined(h[y]);
        }
      ));
    const r = n.metaTokens,
      s = n.visitor || d,
      o = n.dots,
      i = n.indexes,
      u = (n.Blob || (typeof Blob < "u" && Blob)) && f.isSpecCompliantForm(t);
    if (!f.isFunction(s)) throw new TypeError("visitor must be a function");
    function l(p) {
      if (p === null) return "";
      if (f.isDate(p)) return p.toISOString();
      if (!u && f.isBlob(p))
        throw new w("Blob is not supported. Use a Buffer instead.");
      return f.isArrayBuffer(p) || f.isTypedArray(p)
        ? u && typeof Blob == "function"
          ? new Blob([p])
          : Buffer.from(p)
        : p;
    }
    function d(p, y, h) {
      let g = p;
      if (p && !h && typeof p == "object") {
        if (f.endsWith(y, "{}"))
          (y = r ? y : y.slice(0, -2)), (p = JSON.stringify(p));
        else if (
          (f.isArray(p) && jr(p)) ||
          ((f.isFileList(p) || f.endsWith(y, "[]")) && (g = f.toArray(p)))
        )
          return (
            (y = Xt(y)),
            g.forEach(function (A, T) {
              !(f.isUndefined(A) || A === null) &&
                t.append(
                  i === !0 ? Gt([y], T, o) : i === null ? y : y + "[]",
                  l(A)
                );
            }),
            !1
          );
      }
      return qe(p) ? !0 : (t.append(Gt(h, y, o), l(p)), !1);
    }
    const c = [],
      _ = Object.assign($r, {
        defaultVisitor: d,
        convertValue: l,
        isVisitable: qe,
      });
    function m(p, y) {
      if (!f.isUndefined(p)) {
        if (c.indexOf(p) !== -1)
          throw Error("Circular reference detected in " + y.join("."));
        c.push(p),
          f.forEach(p, function (g, b) {
            (!(f.isUndefined(g) || g === null) &&
              s.call(t, g, f.isString(b) ? b.trim() : b, y, _)) === !0 &&
              m(g, y ? y.concat(b) : [b]);
          }),
          c.pop();
      }
    }
    if (!f.isObject(e)) throw new TypeError("data must be an object");
    return m(e), t;
  }
  function Zt(e) {
    const t = {
      "!": "%21",
      "'": "%27",
      "(": "%28",
      ")": "%29",
      "~": "%7E",
      "%20": "+",
      "%00": "\0",
    };
    return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function (r) {
      return t[r];
    });
  }
  function Me(e, t) {
    (this._pairs = []), e && me(e, this, t);
  }
  const Yt = Me.prototype;
  (Yt.append = function (t, n) {
    this._pairs.push([t, n]);
  }),
    (Yt.toString = function (t) {
      const n = t
        ? function (r) {
            return t.call(this, r, Zt);
          }
        : Zt;
      return this._pairs
        .map(function (s) {
          return n(s[0]) + "=" + n(s[1]);
        }, "")
        .join("&");
    });
  function Br(e) {
    return encodeURIComponent(e)
      .replace(/%3A/gi, ":")
      .replace(/%24/g, "$")
      .replace(/%2C/gi, ",")
      .replace(/%20/g, "+")
      .replace(/%5B/gi, "[")
      .replace(/%5D/gi, "]");
  }
  function Qt(e, t, n) {
    if (!t) return e;
    const r = (n && n.encode) || Br;
    f.isFunction(n) && (n = { serialize: n });
    const s = n && n.serialize;
    let o;
    if (
      (s
        ? (o = s(t, n))
        : (o = f.isURLSearchParams(t)
            ? t.toString()
            : new Me(t, n).toString(r)),
      o)
    ) {
      const i = e.indexOf("#");
      i !== -1 && (e = e.slice(0, i)),
        (e += (e.indexOf("?") === -1 ? "?" : "&") + o);
    }
    return e;
  }
  class en {
    constructor() {
      this.handlers = [];
    }
    use(t, n, r) {
      return (
        this.handlers.push({
          fulfilled: t,
          rejected: n,
          synchronous: r ? r.synchronous : !1,
          runWhen: r ? r.runWhen : null,
        }),
        this.handlers.length - 1
      );
    }
    eject(t) {
      this.handlers[t] && (this.handlers[t] = null);
    }
    clear() {
      this.handlers && (this.handlers = []);
    }
    forEach(t) {
      f.forEach(this.handlers, function (r) {
        r !== null && t(r);
      });
    }
  }
  const tn = {
      silentJSONParsing: !0,
      forcedJSONParsing: !0,
      clarifyTimeoutError: !1,
    },
    Ir = {
      isBrowser: !0,
      classes: {
        URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Me,
        FormData: typeof FormData < "u" ? FormData : null,
        Blob: typeof Blob < "u" ? Blob : null,
      },
      protocols: ["http", "https", "file", "blob", "url", "data"],
    },
    ze = typeof window < "u" && typeof document < "u",
    We = (typeof navigator == "object" && navigator) || void 0,
    Hr =
      ze &&
      (!We || ["ReactNative", "NativeScript", "NS"].indexOf(We.product) < 0),
    qr =
      typeof WorkerGlobalScope < "u" &&
      self instanceof WorkerGlobalScope &&
      typeof self.importScripts == "function",
    Mr = (ze && window.location.href) || "http://localhost",
    L = {
      ...Object.freeze(
        Object.defineProperty(
          {
            __proto__: null,
            hasBrowserEnv: ze,
            hasStandardBrowserEnv: Hr,
            hasStandardBrowserWebWorkerEnv: qr,
            navigator: We,
            origin: Mr,
          },
          Symbol.toStringTag,
          { value: "Module" }
        )
      ),
      ...Ir,
    };
  function zr(e, t) {
    return me(
      e,
      new L.classes.URLSearchParams(),
      Object.assign(
        {
          visitor: function (n, r, s, o) {
            return L.isNode && f.isBuffer(n)
              ? (this.append(r, n.toString("base64")), !1)
              : o.defaultVisitor.apply(this, arguments);
          },
        },
        t
      )
    );
  }
  function Wr(e) {
    return f
      .matchAll(/\w+|\[(\w*)]/g, e)
      .map((t) => (t[0] === "[]" ? "" : t[1] || t[0]));
  }
  function Jr(e) {
    const t = {},
      n = Object.keys(e);
    let r;
    const s = n.length;
    let o;
    for (r = 0; r < s; r++) (o = n[r]), (t[o] = e[o]);
    return t;
  }
  function nn(e) {
    function t(n, r, s, o) {
      let i = n[o++];
      if (i === "__proto__") return !0;
      const a = Number.isFinite(+i),
        u = o >= n.length;
      return (
        (i = !i && f.isArray(s) ? s.length : i),
        u
          ? (f.hasOwnProp(s, i) ? (s[i] = [s[i], r]) : (s[i] = r), !a)
          : ((!s[i] || !f.isObject(s[i])) && (s[i] = []),
            t(n, r, s[i], o) && f.isArray(s[i]) && (s[i] = Jr(s[i])),
            !a)
      );
    }
    if (f.isFormData(e) && f.isFunction(e.entries)) {
      const n = {};
      return (
        f.forEachEntry(e, (r, s) => {
          t(Wr(r), s, n, 0);
        }),
        n
      );
    }
    return null;
  }
  function Vr(e, t, n) {
    if (f.isString(e))
      try {
        return (t || JSON.parse)(e), f.trim(e);
      } catch (r) {
        if (r.name !== "SyntaxError") throw r;
      }
    return (n || JSON.stringify)(e);
  }
  const ne = {
    transitional: tn,
    adapter: ["xhr", "http", "fetch"],
    transformRequest: [
      function (t, n) {
        const r = n.getContentType() || "",
          s = r.indexOf("application/json") > -1,
          o = f.isObject(t);
        if ((o && f.isHTMLForm(t) && (t = new FormData(t)), f.isFormData(t)))
          return s ? JSON.stringify(nn(t)) : t;
        if (
          f.isArrayBuffer(t) ||
          f.isBuffer(t) ||
          f.isStream(t) ||
          f.isFile(t) ||
          f.isBlob(t) ||
          f.isReadableStream(t)
        )
          return t;
        if (f.isArrayBufferView(t)) return t.buffer;
        if (f.isURLSearchParams(t))
          return (
            n.setContentType(
              "application/x-www-form-urlencoded;charset=utf-8",
              !1
            ),
            t.toString()
          );
        let a;
        if (o) {
          if (r.indexOf("application/x-www-form-urlencoded") > -1)
            return zr(t, this.formSerializer).toString();
          if ((a = f.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
            const u = this.env && this.env.FormData;
            return me(
              a ? { "files[]": t } : t,
              u && new u(),
              this.formSerializer
            );
          }
        }
        return o || s ? (n.setContentType("application/json", !1), Vr(t)) : t;
      },
    ],
    transformResponse: [
      function (t) {
        const n = this.transitional || ne.transitional,
          r = n && n.forcedJSONParsing,
          s = this.responseType === "json";
        if (f.isResponse(t) || f.isReadableStream(t)) return t;
        if (t && f.isString(t) && ((r && !this.responseType) || s)) {
          const i = !(n && n.silentJSONParsing) && s;
          try {
            return JSON.parse(t);
          } catch (a) {
            if (i)
              throw a.name === "SyntaxError"
                ? w.from(a, w.ERR_BAD_RESPONSE, this, null, this.response)
                : a;
          }
        }
        return t;
      },
    ],
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: { FormData: L.classes.FormData, Blob: L.classes.Blob },
    validateStatus: function (t) {
      return t >= 200 && t < 300;
    },
    headers: {
      common: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": void 0,
      },
    },
  };
  f.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
    ne.headers[e] = {};
  });
  const Kr = f.toObjectSet([
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent",
    ]),
    Xr = (e) => {
      const t = {};
      let n, r, s;
      return (
        e &&
          e
            .split(
              `
`
            )
            .forEach(function (i) {
              (s = i.indexOf(":")),
                (n = i.substring(0, s).trim().toLowerCase()),
                (r = i.substring(s + 1).trim()),
                !(!n || (t[n] && Kr[n])) &&
                  (n === "set-cookie"
                    ? t[n]
                      ? t[n].push(r)
                      : (t[n] = [r])
                    : (t[n] = t[n] ? t[n] + ", " + r : r));
            }),
        t
      );
    },
    rn = Symbol("internals");
  function re(e) {
    return e && String(e).trim().toLowerCase();
  }
  function ye(e) {
    return e === !1 || e == null ? e : f.isArray(e) ? e.map(ye) : String(e);
  }
  function Gr(e) {
    const t = Object.create(null),
      n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let r;
    for (; (r = n.exec(e)); ) t[r[1]] = r[2];
    return t;
  }
  const Zr = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
  function Je(e, t, n, r, s) {
    if (f.isFunction(r)) return r.call(this, t, n);
    if ((s && (t = n), !!f.isString(t))) {
      if (f.isString(r)) return t.indexOf(r) !== -1;
      if (f.isRegExp(r)) return r.test(t);
    }
  }
  function Yr(e) {
    return e
      .trim()
      .toLowerCase()
      .replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
  }
  function Qr(e, t) {
    const n = f.toCamelCase(" " + t);
    ["get", "set", "has"].forEach((r) => {
      Object.defineProperty(e, r + n, {
        value: function (s, o, i) {
          return this[r].call(this, t, s, o, i);
        },
        configurable: !0,
      });
    });
  }
  let j = class {
    constructor(t) {
      t && this.set(t);
    }
    set(t, n, r) {
      const s = this;
      function o(a, u, l) {
        const d = re(u);
        if (!d) throw new Error("header name must be a non-empty string");
        const c = f.findKey(s, d);
        (!c || s[c] === void 0 || l === !0 || (l === void 0 && s[c] !== !1)) &&
          (s[c || u] = ye(a));
      }
      const i = (a, u) => f.forEach(a, (l, d) => o(l, d, u));
      if (f.isPlainObject(t) || t instanceof this.constructor) i(t, n);
      else if (f.isString(t) && (t = t.trim()) && !Zr(t)) i(Xr(t), n);
      else if (f.isHeaders(t)) for (const [a, u] of t.entries()) o(u, a, r);
      else t != null && o(n, t, r);
      return this;
    }
    get(t, n) {
      if (((t = re(t)), t)) {
        const r = f.findKey(this, t);
        if (r) {
          const s = this[r];
          if (!n) return s;
          if (n === !0) return Gr(s);
          if (f.isFunction(n)) return n.call(this, s, r);
          if (f.isRegExp(n)) return n.exec(s);
          throw new TypeError("parser must be boolean|regexp|function");
        }
      }
    }
    has(t, n) {
      if (((t = re(t)), t)) {
        const r = f.findKey(this, t);
        return !!(r && this[r] !== void 0 && (!n || Je(this, this[r], r, n)));
      }
      return !1;
    }
    delete(t, n) {
      const r = this;
      let s = !1;
      function o(i) {
        if (((i = re(i)), i)) {
          const a = f.findKey(r, i);
          a && (!n || Je(r, r[a], a, n)) && (delete r[a], (s = !0));
        }
      }
      return f.isArray(t) ? t.forEach(o) : o(t), s;
    }
    clear(t) {
      const n = Object.keys(this);
      let r = n.length,
        s = !1;
      for (; r--; ) {
        const o = n[r];
        (!t || Je(this, this[o], o, t, !0)) && (delete this[o], (s = !0));
      }
      return s;
    }
    normalize(t) {
      const n = this,
        r = {};
      return (
        f.forEach(this, (s, o) => {
          const i = f.findKey(r, o);
          if (i) {
            (n[i] = ye(s)), delete n[o];
            return;
          }
          const a = t ? Yr(o) : String(o).trim();
          a !== o && delete n[o], (n[a] = ye(s)), (r[a] = !0);
        }),
        this
      );
    }
    concat(...t) {
      return this.constructor.concat(this, ...t);
    }
    toJSON(t) {
      const n = Object.create(null);
      return (
        f.forEach(this, (r, s) => {
          r != null &&
            r !== !1 &&
            (n[s] = t && f.isArray(r) ? r.join(", ") : r);
        }),
        n
      );
    }
    [Symbol.iterator]() {
      return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
      return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
    }
    get [Symbol.toStringTag]() {
      return "AxiosHeaders";
    }
    static from(t) {
      return t instanceof this ? t : new this(t);
    }
    static concat(t, ...n) {
      const r = new this(t);
      return n.forEach((s) => r.set(s)), r;
    }
    static accessor(t) {
      const r = (this[rn] = this[rn] = { accessors: {} }).accessors,
        s = this.prototype;
      function o(i) {
        const a = re(i);
        r[a] || (Qr(s, i), (r[a] = !0));
      }
      return f.isArray(t) ? t.forEach(o) : o(t), this;
    }
  };
  j.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization",
  ]),
    f.reduceDescriptors(j.prototype, ({ value: e }, t) => {
      let n = t[0].toUpperCase() + t.slice(1);
      return {
        get: () => e,
        set(r) {
          this[n] = r;
        },
      };
    }),
    f.freezeMethods(j);
  function Ve(e, t) {
    const n = this || ne,
      r = t || n,
      s = j.from(r.headers);
    let o = r.data;
    return (
      f.forEach(e, function (a) {
        o = a.call(n, o, s.normalize(), t ? t.status : void 0);
      }),
      s.normalize(),
      o
    );
  }
  function sn(e) {
    return !!(e && e.__CANCEL__);
  }
  function Z(e, t, n) {
    w.call(this, e ?? "canceled", w.ERR_CANCELED, t, n),
      (this.name = "CanceledError");
  }
  f.inherits(Z, w, { __CANCEL__: !0 });
  function on(e, t, n) {
    const r = n.config.validateStatus;
    !n.status || !r || r(n.status)
      ? e(n)
      : t(
          new w(
            "Request failed with status code " + n.status,
            [w.ERR_BAD_REQUEST, w.ERR_BAD_RESPONSE][
              Math.floor(n.status / 100) - 4
            ],
            n.config,
            n.request,
            n
          )
        );
  }
  function es(e) {
    const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return (t && t[1]) || "";
  }
  function ts(e, t) {
    e = e || 10;
    const n = new Array(e),
      r = new Array(e);
    let s = 0,
      o = 0,
      i;
    return (
      (t = t !== void 0 ? t : 1e3),
      function (u) {
        const l = Date.now(),
          d = r[o];
        i || (i = l), (n[s] = u), (r[s] = l);
        let c = o,
          _ = 0;
        for (; c !== s; ) (_ += n[c++]), (c = c % e);
        if (((s = (s + 1) % e), s === o && (o = (o + 1) % e), l - i < t))
          return;
        const m = d && l - d;
        return m ? Math.round((_ * 1e3) / m) : void 0;
      }
    );
  }
  function ns(e, t) {
    let n = 0,
      r = 1e3 / t,
      s,
      o;
    const i = (l, d = Date.now()) => {
      (n = d), (s = null), o && (clearTimeout(o), (o = null)), e.apply(null, l);
    };
    return [
      (...l) => {
        const d = Date.now(),
          c = d - n;
        c >= r
          ? i(l, d)
          : ((s = l),
            o ||
              (o = setTimeout(() => {
                (o = null), i(s);
              }, r - c)));
      },
      () => s && i(s),
    ];
  }
  const ge = (e, t, n = 3) => {
      let r = 0;
      const s = ts(50, 250);
      return ns((o) => {
        const i = o.loaded,
          a = o.lengthComputable ? o.total : void 0,
          u = i - r,
          l = s(u),
          d = i <= a;
        r = i;
        const c = {
          loaded: i,
          total: a,
          progress: a ? i / a : void 0,
          bytes: u,
          rate: l || void 0,
          estimated: l && a && d ? (a - i) / l : void 0,
          event: o,
          lengthComputable: a != null,
          [t ? "download" : "upload"]: !0,
        };
        e(c);
      }, n);
    },
    an = (e, t) => {
      const n = e != null;
      return [(r) => t[0]({ lengthComputable: n, total: e, loaded: r }), t[1]];
    },
    cn =
      (e) =>
      (...t) =>
        f.asap(() => e(...t)),
    rs = L.hasStandardBrowserEnv
      ? ((e, t) => (n) => (
          (n = new URL(n, L.origin)),
          e.protocol === n.protocol &&
            e.host === n.host &&
            (t || e.port === n.port)
        ))(
          new URL(L.origin),
          L.navigator && /(msie|trident)/i.test(L.navigator.userAgent)
        )
      : () => !0,
    ss = L.hasStandardBrowserEnv
      ? {
          write(e, t, n, r, s, o) {
            const i = [e + "=" + encodeURIComponent(t)];
            f.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()),
              f.isString(r) && i.push("path=" + r),
              f.isString(s) && i.push("domain=" + s),
              o === !0 && i.push("secure"),
              (document.cookie = i.join("; "));
          },
          read(e) {
            const t = document.cookie.match(
              new RegExp("(^|;\\s*)(" + e + ")=([^;]*)")
            );
            return t ? decodeURIComponent(t[3]) : null;
          },
          remove(e) {
            this.write(e, "", Date.now() - 864e5);
          },
        }
      : {
          write() {},
          read() {
            return null;
          },
          remove() {},
        };
  function os(e) {
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  }
  function is(e, t) {
    return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
  }
  function ln(e, t) {
    return e && !os(t) ? is(e, t) : t;
  }
  const un = (e) => (e instanceof j ? { ...e } : e);
  function V(e, t) {
    t = t || {};
    const n = {};
    function r(l, d, c, _) {
      return f.isPlainObject(l) && f.isPlainObject(d)
        ? f.merge.call({ caseless: _ }, l, d)
        : f.isPlainObject(d)
        ? f.merge({}, d)
        : f.isArray(d)
        ? d.slice()
        : d;
    }
    function s(l, d, c, _) {
      if (f.isUndefined(d)) {
        if (!f.isUndefined(l)) return r(void 0, l, c, _);
      } else return r(l, d, c, _);
    }
    function o(l, d) {
      if (!f.isUndefined(d)) return r(void 0, d);
    }
    function i(l, d) {
      if (f.isUndefined(d)) {
        if (!f.isUndefined(l)) return r(void 0, l);
      } else return r(void 0, d);
    }
    function a(l, d, c) {
      if (c in t) return r(l, d);
      if (c in e) return r(void 0, l);
    }
    const u = {
      url: o,
      method: o,
      data: o,
      baseURL: i,
      transformRequest: i,
      transformResponse: i,
      paramsSerializer: i,
      timeout: i,
      timeoutMessage: i,
      withCredentials: i,
      withXSRFToken: i,
      adapter: i,
      responseType: i,
      xsrfCookieName: i,
      xsrfHeaderName: i,
      onUploadProgress: i,
      onDownloadProgress: i,
      decompress: i,
      maxContentLength: i,
      maxBodyLength: i,
      beforeRedirect: i,
      transport: i,
      httpAgent: i,
      httpsAgent: i,
      cancelToken: i,
      socketPath: i,
      responseEncoding: i,
      validateStatus: a,
      headers: (l, d, c) => s(un(l), un(d), c, !0),
    };
    return (
      f.forEach(Object.keys(Object.assign({}, e, t)), function (d) {
        const c = u[d] || s,
          _ = c(e[d], t[d], d);
        (f.isUndefined(_) && c !== a) || (n[d] = _);
      }),
      n
    );
  }
  const fn = (e) => {
      const t = V({}, e);
      let {
        data: n,
        withXSRFToken: r,
        xsrfHeaderName: s,
        xsrfCookieName: o,
        headers: i,
        auth: a,
      } = t;
      (t.headers = i = j.from(i)),
        (t.url = Qt(ln(t.baseURL, t.url), e.params, e.paramsSerializer)),
        a &&
          i.set(
            "Authorization",
            "Basic " +
              btoa(
                (a.username || "") +
                  ":" +
                  (a.password ? unescape(encodeURIComponent(a.password)) : "")
              )
          );
      let u;
      if (f.isFormData(n)) {
        if (L.hasStandardBrowserEnv || L.hasStandardBrowserWebWorkerEnv)
          i.setContentType(void 0);
        else if ((u = i.getContentType()) !== !1) {
          const [l, ...d] = u
            ? u
                .split(";")
                .map((c) => c.trim())
                .filter(Boolean)
            : [];
          i.setContentType([l || "multipart/form-data", ...d].join("; "));
        }
      }
      if (
        L.hasStandardBrowserEnv &&
        (r && f.isFunction(r) && (r = r(t)), r || (r !== !1 && rs(t.url)))
      ) {
        const l = s && o && ss.read(o);
        l && i.set(s, l);
      }
      return t;
    },
    as =
      typeof XMLHttpRequest < "u" &&
      function (e) {
        return new Promise(function (n, r) {
          const s = fn(e);
          let o = s.data;
          const i = j.from(s.headers).normalize();
          let {
              responseType: a,
              onUploadProgress: u,
              onDownloadProgress: l,
            } = s,
            d,
            c,
            _,
            m,
            p;
          function y() {
            m && m(),
              p && p(),
              s.cancelToken && s.cancelToken.unsubscribe(d),
              s.signal && s.signal.removeEventListener("abort", d);
          }
          let h = new XMLHttpRequest();
          h.open(s.method.toUpperCase(), s.url, !0), (h.timeout = s.timeout);
          function g() {
            if (!h) return;
            const A = j.from(
                "getAllResponseHeaders" in h && h.getAllResponseHeaders()
              ),
              C = {
                data:
                  !a || a === "text" || a === "json"
                    ? h.responseText
                    : h.response,
                status: h.status,
                statusText: h.statusText,
                headers: A,
                config: e,
                request: h,
              };
            on(
              function (E) {
                n(E), y();
              },
              function (E) {
                r(E), y();
              },
              C
            ),
              (h = null);
          }
          "onloadend" in h
            ? (h.onloadend = g)
            : (h.onreadystatechange = function () {
                !h ||
                  h.readyState !== 4 ||
                  (h.status === 0 &&
                    !(h.responseURL && h.responseURL.indexOf("file:") === 0)) ||
                  setTimeout(g);
              }),
            (h.onabort = function () {
              h &&
                (r(new w("Request aborted", w.ECONNABORTED, e, h)), (h = null));
            }),
            (h.onerror = function () {
              r(new w("Network Error", w.ERR_NETWORK, e, h)), (h = null);
            }),
            (h.ontimeout = function () {
              let T = s.timeout
                ? "timeout of " + s.timeout + "ms exceeded"
                : "timeout exceeded";
              const C = s.transitional || tn;
              s.timeoutErrorMessage && (T = s.timeoutErrorMessage),
                r(
                  new w(
                    T,
                    C.clarifyTimeoutError ? w.ETIMEDOUT : w.ECONNABORTED,
                    e,
                    h
                  )
                ),
                (h = null);
            }),
            o === void 0 && i.setContentType(null),
            "setRequestHeader" in h &&
              f.forEach(i.toJSON(), function (T, C) {
                h.setRequestHeader(C, T);
              }),
            f.isUndefined(s.withCredentials) ||
              (h.withCredentials = !!s.withCredentials),
            a && a !== "json" && (h.responseType = s.responseType),
            l && (([_, p] = ge(l, !0)), h.addEventListener("progress", _)),
            u &&
              h.upload &&
              (([c, m] = ge(u)),
              h.upload.addEventListener("progress", c),
              h.upload.addEventListener("loadend", m)),
            (s.cancelToken || s.signal) &&
              ((d = (A) => {
                h &&
                  (r(!A || A.type ? new Z(null, e, h) : A),
                  h.abort(),
                  (h = null));
              }),
              s.cancelToken && s.cancelToken.subscribe(d),
              s.signal &&
                (s.signal.aborted
                  ? d()
                  : s.signal.addEventListener("abort", d)));
          const b = es(s.url);
          if (b && L.protocols.indexOf(b) === -1) {
            r(new w("Unsupported protocol " + b + ":", w.ERR_BAD_REQUEST, e));
            return;
          }
          h.send(o || null);
        });
      },
    cs = (e, t) => {
      const { length: n } = (e = e ? e.filter(Boolean) : []);
      if (t || n) {
        let r = new AbortController(),
          s;
        const o = function (l) {
          if (!s) {
            (s = !0), a();
            const d = l instanceof Error ? l : this.reason;
            r.abort(
              d instanceof w ? d : new Z(d instanceof Error ? d.message : d)
            );
          }
        };
        let i =
          t &&
          setTimeout(() => {
            (i = null), o(new w(`timeout ${t} of ms exceeded`, w.ETIMEDOUT));
          }, t);
        const a = () => {
          e &&
            (i && clearTimeout(i),
            (i = null),
            e.forEach((l) => {
              l.unsubscribe
                ? l.unsubscribe(o)
                : l.removeEventListener("abort", o);
            }),
            (e = null));
        };
        e.forEach((l) => l.addEventListener("abort", o));
        const { signal: u } = r;
        return (u.unsubscribe = () => f.asap(a)), u;
      }
    },
    ls = function* (e, t) {
      let n = e.byteLength;
      if (n < t) {
        yield e;
        return;
      }
      let r = 0,
        s;
      for (; r < n; ) (s = r + t), yield e.slice(r, s), (r = s);
    },
    us = async function* (e, t) {
      for await (const n of fs(e)) yield* ls(n, t);
    },
    fs = async function* (e) {
      if (e[Symbol.asyncIterator]) {
        yield* e;
        return;
      }
      const t = e.getReader();
      try {
        for (;;) {
          const { done: n, value: r } = await t.read();
          if (n) break;
          yield r;
        }
      } finally {
        await t.cancel();
      }
    },
    dn = (e, t, n, r) => {
      const s = us(e, t);
      let o = 0,
        i,
        a = (u) => {
          i || ((i = !0), r && r(u));
        };
      return new ReadableStream(
        {
          async pull(u) {
            try {
              const { done: l, value: d } = await s.next();
              if (l) {
                a(), u.close();
                return;
              }
              let c = d.byteLength;
              if (n) {
                let _ = (o += c);
                n(_);
              }
              u.enqueue(new Uint8Array(d));
            } catch (l) {
              throw (a(l), l);
            }
          },
          cancel(u) {
            return a(u), s.return();
          },
        },
        { highWaterMark: 2 }
      );
    },
    be =
      typeof fetch == "function" &&
      typeof Request == "function" &&
      typeof Response == "function",
    _n = be && typeof ReadableStream == "function",
    ds =
      be &&
      (typeof TextEncoder == "function"
        ? (
            (e) => (t) =>
              e.encode(t)
          )(new TextEncoder())
        : async (e) => new Uint8Array(await new Response(e).arrayBuffer())),
    pn = (e, ...t) => {
      try {
        return !!e(...t);
      } catch {
        return !1;
      }
    },
    _s =
      _n &&
      pn(() => {
        let e = !1;
        const t = new Request(L.origin, {
          body: new ReadableStream(),
          method: "POST",
          get duplex() {
            return (e = !0), "half";
          },
        }).headers.has("Content-Type");
        return e && !t;
      }),
    hn = 64 * 1024,
    Ke = _n && pn(() => f.isReadableStream(new Response("").body)),
    we = { stream: Ke && ((e) => e.body) };
  be &&
    ((e) => {
      ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
        !we[t] &&
          (we[t] = f.isFunction(e[t])
            ? (n) => n[t]()
            : (n, r) => {
                throw new w(
                  `Response type '${t}' is not supported`,
                  w.ERR_NOT_SUPPORT,
                  r
                );
              });
      });
    })(new Response());
  const ps = async (e) => {
      if (e == null) return 0;
      if (f.isBlob(e)) return e.size;
      if (f.isSpecCompliantForm(e))
        return (
          await new Request(L.origin, { method: "POST", body: e }).arrayBuffer()
        ).byteLength;
      if (f.isArrayBufferView(e) || f.isArrayBuffer(e)) return e.byteLength;
      if ((f.isURLSearchParams(e) && (e = e + ""), f.isString(e)))
        return (await ds(e)).byteLength;
    },
    hs = async (e, t) => {
      const n = f.toFiniteNumber(e.getContentLength());
      return n ?? ps(t);
    },
    Xe = {
      http: vr,
      xhr: as,
      fetch:
        be &&
        (async (e) => {
          let {
            url: t,
            method: n,
            data: r,
            signal: s,
            cancelToken: o,
            timeout: i,
            onDownloadProgress: a,
            onUploadProgress: u,
            responseType: l,
            headers: d,
            withCredentials: c = "same-origin",
            fetchOptions: _,
          } = fn(e);
          l = l ? (l + "").toLowerCase() : "text";
          let m = cs([s, o && o.toAbortSignal()], i),
            p;
          const y =
            m &&
            m.unsubscribe &&
            (() => {
              m.unsubscribe();
            });
          let h;
          try {
            if (
              u &&
              _s &&
              n !== "get" &&
              n !== "head" &&
              (h = await hs(d, r)) !== 0
            ) {
              let C = new Request(t, {
                  method: "POST",
                  body: r,
                  duplex: "half",
                }),
                U;
              if (
                (f.isFormData(r) &&
                  (U = C.headers.get("content-type")) &&
                  d.setContentType(U),
                C.body)
              ) {
                const [E, S] = an(h, ge(cn(u)));
                r = dn(C.body, hn, E, S);
              }
            }
            f.isString(c) || (c = c ? "include" : "omit");
            const g = "credentials" in Request.prototype;
            p = new Request(t, {
              ..._,
              signal: m,
              method: n.toUpperCase(),
              headers: d.normalize().toJSON(),
              body: r,
              duplex: "half",
              credentials: g ? c : void 0,
            });
            let b = await fetch(p);
            const A = Ke && (l === "stream" || l === "response");
            if (Ke && (a || (A && y))) {
              const C = {};
              ["status", "statusText", "headers"].forEach((k) => {
                C[k] = b[k];
              });
              const U = f.toFiniteNumber(b.headers.get("content-length")),
                [E, S] = (a && an(U, ge(cn(a), !0))) || [];
              b = new Response(
                dn(b.body, hn, E, () => {
                  S && S(), y && y();
                }),
                C
              );
            }
            l = l || "text";
            let T = await we[f.findKey(we, l) || "text"](b, e);
            return (
              !A && y && y(),
              await new Promise((C, U) => {
                on(C, U, {
                  data: T,
                  headers: j.from(b.headers),
                  status: b.status,
                  statusText: b.statusText,
                  config: e,
                  request: p,
                });
              })
            );
          } catch (g) {
            throw (
              (y && y(),
              g && g.name === "TypeError" && /fetch/i.test(g.message)
                ? Object.assign(new w("Network Error", w.ERR_NETWORK, e, p), {
                    cause: g.cause || g,
                  })
                : w.from(g, g && g.code, e, p))
            );
          }
        }),
    };
  f.forEach(Xe, (e, t) => {
    if (e) {
      try {
        Object.defineProperty(e, "name", { value: t });
      } catch {}
      Object.defineProperty(e, "adapterName", { value: t });
    }
  });
  const mn = (e) => `- ${e}`,
    ms = (e) => f.isFunction(e) || e === null || e === !1,
    yn = {
      getAdapter: (e) => {
        e = f.isArray(e) ? e : [e];
        const { length: t } = e;
        let n, r;
        const s = {};
        for (let o = 0; o < t; o++) {
          n = e[o];
          let i;
          if (
            ((r = n),
            !ms(n) && ((r = Xe[(i = String(n)).toLowerCase()]), r === void 0))
          )
            throw new w(`Unknown adapter '${i}'`);
          if (r) break;
          s[i || "#" + o] = r;
        }
        if (!r) {
          const o = Object.entries(s).map(
            ([a, u]) =>
              `adapter ${a} ` +
              (u === !1
                ? "is not supported by the environment"
                : "is not available in the build")
          );
          let i = t
            ? o.length > 1
              ? `since :
` +
                o.map(mn).join(`
`)
              : " " + mn(o[0])
            : "as no adapter specified";
          throw new w(
            "There is no suitable adapter to dispatch the request " + i,
            "ERR_NOT_SUPPORT"
          );
        }
        return r;
      },
      adapters: Xe,
    };
  function Ge(e) {
    if (
      (e.cancelToken && e.cancelToken.throwIfRequested(),
      e.signal && e.signal.aborted)
    )
      throw new Z(null, e);
  }
  function gn(e) {
    return (
      Ge(e),
      (e.headers = j.from(e.headers)),
      (e.data = Ve.call(e, e.transformRequest)),
      ["post", "put", "patch"].indexOf(e.method) !== -1 &&
        e.headers.setContentType("application/x-www-form-urlencoded", !1),
      yn
        .getAdapter(e.adapter || ne.adapter)(e)
        .then(
          function (r) {
            return (
              Ge(e),
              (r.data = Ve.call(e, e.transformResponse, r)),
              (r.headers = j.from(r.headers)),
              r
            );
          },
          function (r) {
            return (
              sn(r) ||
                (Ge(e),
                r &&
                  r.response &&
                  ((r.response.data = Ve.call(
                    e,
                    e.transformResponse,
                    r.response
                  )),
                  (r.response.headers = j.from(r.response.headers)))),
              Promise.reject(r)
            );
          }
        )
    );
  }
  const bn = "1.7.9",
    Ee = {};
  ["object", "boolean", "number", "function", "string", "symbol"].forEach(
    (e, t) => {
      Ee[e] = function (r) {
        return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
      };
    }
  );
  const wn = {};
  (Ee.transitional = function (t, n, r) {
    function s(o, i) {
      return (
        "[Axios v" +
        bn +
        "] Transitional option '" +
        o +
        "'" +
        i +
        (r ? ". " + r : "")
      );
    }
    return (o, i, a) => {
      if (t === !1)
        throw new w(
          s(i, " has been removed" + (n ? " in " + n : "")),
          w.ERR_DEPRECATED
        );
      return (
        n &&
          !wn[i] &&
          ((wn[i] = !0),
          console.warn(
            s(
              i,
              " has been deprecated since v" +
                n +
                " and will be removed in the near future"
            )
          )),
        t ? t(o, i, a) : !0
      );
    };
  }),
    (Ee.spelling = function (t) {
      return (n, r) => (
        console.warn(`${r} is likely a misspelling of ${t}`), !0
      );
    });
  function ys(e, t, n) {
    if (typeof e != "object")
      throw new w("options must be an object", w.ERR_BAD_OPTION_VALUE);
    const r = Object.keys(e);
    let s = r.length;
    for (; s-- > 0; ) {
      const o = r[s],
        i = t[o];
      if (i) {
        const a = e[o],
          u = a === void 0 || i(a, o, e);
        if (u !== !0)
          throw new w("option " + o + " must be " + u, w.ERR_BAD_OPTION_VALUE);
        continue;
      }
      if (n !== !0) throw new w("Unknown option " + o, w.ERR_BAD_OPTION);
    }
  }
  const Se = { assertOptions: ys, validators: Ee },
    I = Se.validators;
  let K = class {
    constructor(t) {
      (this.defaults = t),
        (this.interceptors = { request: new en(), response: new en() });
    }
    async request(t, n) {
      try {
        return await this._request(t, n);
      } catch (r) {
        if (r instanceof Error) {
          let s = {};
          Error.captureStackTrace
            ? Error.captureStackTrace(s)
            : (s = new Error());
          const o = s.stack ? s.stack.replace(/^.+\n/, "") : "";
          try {
            r.stack
              ? o &&
                !String(r.stack).endsWith(o.replace(/^.+\n.+\n/, "")) &&
                (r.stack +=
                  `
` + o)
              : (r.stack = o);
          } catch {}
        }
        throw r;
      }
    }
    _request(t, n) {
      typeof t == "string" ? ((n = n || {}), (n.url = t)) : (n = t || {}),
        (n = V(this.defaults, n));
      const { transitional: r, paramsSerializer: s, headers: o } = n;
      r !== void 0 &&
        Se.assertOptions(
          r,
          {
            silentJSONParsing: I.transitional(I.boolean),
            forcedJSONParsing: I.transitional(I.boolean),
            clarifyTimeoutError: I.transitional(I.boolean),
          },
          !1
        ),
        s != null &&
          (f.isFunction(s)
            ? (n.paramsSerializer = { serialize: s })
            : Se.assertOptions(
                s,
                { encode: I.function, serialize: I.function },
                !0
              )),
        Se.assertOptions(
          n,
          {
            baseUrl: I.spelling("baseURL"),
            withXsrfToken: I.spelling("withXSRFToken"),
          },
          !0
        ),
        (n.method = (n.method || this.defaults.method || "get").toLowerCase());
      let i = o && f.merge(o.common, o[n.method]);
      o &&
        f.forEach(
          ["delete", "get", "head", "post", "put", "patch", "common"],
          (p) => {
            delete o[p];
          }
        ),
        (n.headers = j.concat(i, o));
      const a = [];
      let u = !0;
      this.interceptors.request.forEach(function (y) {
        (typeof y.runWhen == "function" && y.runWhen(n) === !1) ||
          ((u = u && y.synchronous), a.unshift(y.fulfilled, y.rejected));
      });
      const l = [];
      this.interceptors.response.forEach(function (y) {
        l.push(y.fulfilled, y.rejected);
      });
      let d,
        c = 0,
        _;
      if (!u) {
        const p = [gn.bind(this), void 0];
        for (
          p.unshift.apply(p, a),
            p.push.apply(p, l),
            _ = p.length,
            d = Promise.resolve(n);
          c < _;

        )
          d = d.then(p[c++], p[c++]);
        return d;
      }
      _ = a.length;
      let m = n;
      for (c = 0; c < _; ) {
        const p = a[c++],
          y = a[c++];
        try {
          m = p(m);
        } catch (h) {
          y.call(this, h);
          break;
        }
      }
      try {
        d = gn.call(this, m);
      } catch (p) {
        return Promise.reject(p);
      }
      for (c = 0, _ = l.length; c < _; ) d = d.then(l[c++], l[c++]);
      return d;
    }
    getUri(t) {
      t = V(this.defaults, t);
      const n = ln(t.baseURL, t.url);
      return Qt(n, t.params, t.paramsSerializer);
    }
  };
  f.forEach(["delete", "get", "head", "options"], function (t) {
    K.prototype[t] = function (n, r) {
      return this.request(
        V(r || {}, { method: t, url: n, data: (r || {}).data })
      );
    };
  }),
    f.forEach(["post", "put", "patch"], function (t) {
      function n(r) {
        return function (o, i, a) {
          return this.request(
            V(a || {}, {
              method: t,
              headers: r ? { "Content-Type": "multipart/form-data" } : {},
              url: o,
              data: i,
            })
          );
        };
      }
      (K.prototype[t] = n()), (K.prototype[t + "Form"] = n(!0));
    });
  let gs = class On {
    constructor(t) {
      if (typeof t != "function")
        throw new TypeError("executor must be a function.");
      let n;
      this.promise = new Promise(function (o) {
        n = o;
      });
      const r = this;
      this.promise.then((s) => {
        if (!r._listeners) return;
        let o = r._listeners.length;
        for (; o-- > 0; ) r._listeners[o](s);
        r._listeners = null;
      }),
        (this.promise.then = (s) => {
          let o;
          const i = new Promise((a) => {
            r.subscribe(a), (o = a);
          }).then(s);
          return (
            (i.cancel = function () {
              r.unsubscribe(o);
            }),
            i
          );
        }),
        t(function (o, i, a) {
          r.reason || ((r.reason = new Z(o, i, a)), n(r.reason));
        });
    }
    throwIfRequested() {
      if (this.reason) throw this.reason;
    }
    subscribe(t) {
      if (this.reason) {
        t(this.reason);
        return;
      }
      this._listeners ? this._listeners.push(t) : (this._listeners = [t]);
    }
    unsubscribe(t) {
      if (!this._listeners) return;
      const n = this._listeners.indexOf(t);
      n !== -1 && this._listeners.splice(n, 1);
    }
    toAbortSignal() {
      const t = new AbortController(),
        n = (r) => {
          t.abort(r);
        };
      return (
        this.subscribe(n),
        (t.signal.unsubscribe = () => this.unsubscribe(n)),
        t.signal
      );
    }
    static source() {
      let t;
      return {
        token: new On(function (s) {
          t = s;
        }),
        cancel: t,
      };
    }
  };
  function bs(e) {
    return function (n) {
      return e.apply(null, n);
    };
  }
  function ws(e) {
    return f.isObject(e) && e.isAxiosError === !0;
  }
  const Ze = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
  };
  Object.entries(Ze).forEach(([e, t]) => {
    Ze[t] = e;
  });
  function En(e) {
    const t = new K(e),
      n = jt(K.prototype.request, t);
    return (
      f.extend(n, K.prototype, t, { allOwnKeys: !0 }),
      f.extend(n, t, null, { allOwnKeys: !0 }),
      (n.create = function (s) {
        return En(V(e, s));
      }),
      n
    );
  }
  const F = En(ne);
  (F.Axios = K),
    (F.CanceledError = Z),
    (F.CancelToken = gs),
    (F.isCancel = sn),
    (F.VERSION = bn),
    (F.toFormData = me),
    (F.AxiosError = w),
    (F.Cancel = F.CanceledError),
    (F.all = function (t) {
      return Promise.all(t);
    }),
    (F.spread = bs),
    (F.isAxiosError = ws),
    (F.mergeConfig = V),
    (F.AxiosHeaders = j),
    (F.formToJSON = (e) => nn(f.isHTMLForm(e) ? new FormData(e) : e)),
    (F.getAdapter = yn.getAdapter),
    (F.HttpStatusCode = Ze),
    (F.default = F);
  const {
      Axios: Ns,
      AxiosError: Ps,
      CanceledError: ks,
      isCancel: Ds,
      CancelToken: Ls,
      VERSION: Us,
      all: vs,
      Cancel: js,
      isAxiosError: $s,
      spread: Bs,
      toFormData: Is,
      AxiosHeaders: Hs,
      HttpStatusCode: qs,
      formToJSON: Ms,
      getAdapter: zs,
      mergeConfig: Ws,
    } = F,
    Es = "http://misc.pdsync.com.au/zendesk-api",
    Sn = "6LcueJoqAAAAAD6b6vhZp8yq0Nf-Ti-g06rbXPi0",
    Rn = 5,
    Ss = 5 * 1024 * 1024,
    An =
      "image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    Rs = () => {
      const e = vn(null),
        [t, n] = M(!1),
        [r, s] = M({ subject: "", description: "", name: "", email: "" }),
        [o, i] = M(null),
        [a, u] = M([]),
        [l, d] = M(!1),
        [c, _] = M(""),
        [m, p] = M(""),
        [y, h] = M("default");
      Et(() => {
        const S = Gn.parse(window.location.search).theme || "default";
        h(S), (document.body.className = `theme-${S}`);
      }, []),
        Et(() => {
          if (window.recaptchaReady)
            window.grecaptcha.ready(() => {
              window.grecaptcha.render(e.current, {
                sitekey: Sn,
                callback: (E) => {
                  i(E);
                },
              }),
                n(!0);
            });
          else {
            const E = setInterval(() => {
              window.recaptchaReady &&
                (window.grecaptcha.ready(() => {
                  window.grecaptcha.render(e.current, {
                    sitekey: Sn,
                    callback: (S) => {
                      i(S);
                    },
                  }),
                    n(!0);
                }),
                clearInterval(E));
            }, 500);
          }
        }, []);
      const g = (E) => {
          E.preventDefault(),
            E.stopPropagation(),
            (E.dataTransfer.dropEffect = "copy");
        },
        b = (E) => {
          E.preventDefault(), E.stopPropagation();
          let S;
          if (
            (E.dataTransfer
              ? (S = Array.from(E.dataTransfer.files))
              : E.target && E.target.files && (S = Array.from(E.target.files)),
            a.length + S.length > Rn)
          ) {
            _(`You can upload a maximum of ${Rn} files.`);
            return;
          }
          const k = S.filter(
            (D) =>
              new RegExp(An.replace(/,/g, "|").replace(/\s/g, "")).test(
                D.type
              ) && D.size <= Ss
          );
          k.length < S.length &&
            _(
              "Some files are either too large (max 5MB) or not a supported type."
            ),
            u((D) => [...D, ...k]);
        },
        A = () =>
          !r.subject.trim() ||
          !r.description.trim() ||
          !r.name.trim() ||
          !r.email.trim()
            ? (_("All fields are required."), !1)
            : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(r.email)
            ? !0
            : (_("Invalid email format."), !1),
        T = (E) => {
          const { name: S, value: k } = E.target;
          s((D) => ({ ...D, [S]: k }));
        },
        C = (E, S) => {
          E.preventDefault(),
            E.stopPropagation(),
            u((k) => k.filter((D, v) => v !== S));
        },
        U = async (E) => {
          if ((E.preventDefault(), _(""), p(""), !A() || !o)) return;
          d(!0);
          const S = {
              subject: r.subject,
              description: r.description,
              name: r.name,
              email: r.email,
              captchaToken: o,
              country: window.pdCustomCountry || "australia",
              website: window.pdCustomWebSite || "unknown",
            },
            k = new FormData();
          Object.entries(S).forEach(([D, v]) => {
            k.append(D, v);
          }),
            a.forEach((D, v) => {
              k.append("files", D);
            });
          try {
            (
              await F.post(`${Es}/submit`, k, {
                headers: { "Content-Type": "multipart/form-data" },
              })
            ).status === 200
              ? (p("Form submitted successfully!"),
                s({ subject: "", description: "", name: "", email: "" }),
                u([]),
                i(null),
                setTimeout(() => {
                  p("");
                }, 1500))
              : _("An unexpected error occurred.");
          } catch (D) {
            console.error("Error submitting form:", D),
              _("Failed to submit the form.");
          } finally {
            d(!1);
          }
        };
      return O("div", {
        className: `form-container theme-${y}`,
        children: [
          O("h1", { children: "Contact Us" }),
          c && O("p", { className: "error", children: c }),
          m && O("p", { className: "success", children: m }),
          O("form", {
            onSubmit: U,
            children: [
              O("label", {
                children: [
                  "Subject:",
                  O("input", {
                    type: "text",
                    name: "subject",
                    value: r.subject,
                    onChange: T,
                    required: !0,
                  }),
                ],
              }),
              O("label", {
                children: [
                  "Description:",
                  O("textarea", {
                    name: "description",
                    value: r.description,
                    onChange: T,
                    required: !0,
                  }),
                ],
              }),
              O("label", {
                children: [
                  "Name:",
                  O("input", {
                    type: "text",
                    name: "name",
                    value: r.name,
                    onChange: T,
                    required: !0,
                  }),
                ],
              }),
              O("label", {
                children: [
                  "Email:",
                  O("input", {
                    type: "email",
                    name: "email",
                    value: r.email,
                    onChange: T,
                    required: !0,
                  }),
                ],
              }),
              O("label", {
                children: [
                  "Attachments:",
                  O("div", {
                    onDrop: b,
                    onDragOver: g,
                    className: "dropzone",
                    children: [
                      O("p", {
                        children:
                          "Drag and drop files here, or click to select files",
                      }),
                      O("input", {
                        type: "file",
                        onChange: b,
                        accept: An,
                        multiple: !0,
                        style: { display: "none" },
                      }),
                    ],
                  }),
                  O("ul", {
                    children: a.map((E, S) =>
                      O(
                        "li",
                        {
                          children: [
                            E.name,
                            O("button", {
                              type: "button",
                              onClick: (k) => C(k, S),
                              className: "remove-file",
                              children: "X",
                            }),
                          ],
                        },
                        S
                      )
                    ),
                  }),
                ],
              }),
              O("div", { ref: e }),
              O("button", {
                type: "submit",
                disabled: l,
                children: l ? "Submitting..." : "Submit",
              }),
            ],
          }),
        ],
      });
    },
    Tn = () => {
      const e = document.getElementById("pd-zendesk-form");
      e && ((e.innerHTML = ""), kn(Ce(Rs), e));
    };
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", Tn)
    : Tn();
});
//# sourceMappingURL=pd-zendesk-form.umd.js.map
